import type { ReleaseEntry } from "../../../web/lib/releaseNotes";

type ReleaseSource = Pick<ReleaseEntry, "version" | "date" | "title" | "confidence" | "audience"> & { items: string[] };

// Generated from the reviewed v202-v461 changelog. Do not edit individual entries by hand.
const releaseSources: ReleaseSource[] = [
  {
    "version": 461,
    "date": "2026-07-30",
    "title": "JTL Sipariş Saat Dilimi Dönüşümü Düzeltilip Sunucuya Dağıtıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "JTL bridge 1.2.1 doğrudan sunucuya yedek alınarak dağıtıldı.",
      "Sipariş tarihleri doğru Berlin saatinde gösterildi ve canlı senkronla binlerce kayıt yeniden işlendi."
    ]
  },
  {
    "version": 460,
    "date": "2026-07-28",
    "title": "Afterbuy Takip Numarası Geri Yazma Akışı Canlıya Alındı",
    "confidence": "implemented",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiket oluşturulduğunda takip numarası doğrudan Afterbuy siparişine ve sipariş içe alma aralığından bağımsız olarak hemen yazılıyor.",
      "Ana platformla eşleşen siparişlerde takip hem eBay veya Amazon’a hem Afterbuy’a iletiliyor.",
      "Mevcut paket numarası, mükerrer takip, hata kaydı ve yeniden deneme korumaları eklendi."
    ]
  },
  {
    "version": 459,
    "date": "2026-07-28",
    "title": "JTL Versanddatenimport ve Güvenli SFTP Kuyruk Altyapısı Hazırlandı",
    "confidence": "implemented",
    "audience": [
      "system"
    ],
    "items": [
      "JTL bridge 1.2.0 ile açık irsaliye hazırlama, atomik SFTP aktarımı, Windows ajanı ve mükerrer işlem koruması eklendi.",
      "Canlı MSSQL bağlantısı doğrulandı; müşteri tarafındaki JTL workflow kurulumu tamamlanana kadar özellik güvenli biçimde kapalı tutuldu."
    ]
  },
  {
    "version": 458,
    "date": "2026-07-28",
    "title": "Bir Afterbuy Hesabı Bağlandı ve İlk Sipariş Senkronu Tamamlandı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Afterbuy API bağlantısı doğrulandı; ilk senkronda yeni siparişler oluşturulup mevcut eBay/Amazon kayıtlarıyla eşleşenler tekilleştirildi.",
      "Otomatik kontrol 30 dakikada bir çalışacak, geniş tarama zaman aşımını önlemek için kayan pencereyle ilerleyecek."
    ]
  },
  {
    "version": 457,
    "date": "2026-07-28",
    "title": "Afterbuy Tam Mağaza Entegrasyonu Canlıya Alındı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Afterbuy yeni platform olarak eklendi.",
      "Siparişler otomatik veya manuel alınabiliyor.",
      "Varsayılan senkron aralığı 30 dakika; zamanlayıcı 5 dakikada bir zamanı gelen mağazaları kontrol ediyor."
    ]
  },
  {
    "version": 456,
    "date": "2026-07-28",
    "title": "Billbee Siparişleri Yeniden Senkronlanıp Zamanlayıcı ve Depolama Dayanıklılığı Artırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Billbee’den 1.191 sipariş yeniden senkronlandı; 50 yeni kayıt eklendi ve 1.141 kayıt güncellendi.",
      "Faturalama hatalarının sipariş senkronunu durdurması engellendi.",
      "S3 kesintisinde D1 yazımının devam etmesi için depolama fallback’i eklendi.",
      "Otomatik kontroller mağaza bazında bağımsız kuyruklar halinde çalışacak şekilde ayrıldı."
    ]
  },
  {
    "version": 455,
    "date": "2026-07-27",
    "title": "Eksik Cloudflare Functions Nedeniyle Bozulan Giriş API’si Yeniden Dağıtıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Statik arayüz dağıtılırken eksik kalan Cloudflare Functions yeniden production paketine dahil edildi.",
      "Giriş API’si tekrar doğru JSON yanıtı verir hale geldi.",
      "Mevcut kullanıcı hesaplarının yeniden oturum açabildiği canlıda doğrulandı."
    ]
  },
  {
    "version": 454,
    "date": "2026-07-27",
    "title": "Takılı Kredi İşlemleri İçin Otomatik Kurtarma ve Kilit Açma Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Yarıda kalan kredi işlemi gerçekleşmişse tekrar kredi vermeden tamamlanıyor.",
      "Hiç uygulanmamış işlemde kilit kontrollü süre sonunda açılıyor; mevcut başarılı kredi kayıtları korunuyor."
    ]
  },
  {
    "version": 453,
    "date": "2026-07-27",
    "title": "Affiliate Müşteri Bağlama ve Etiket Başına Komisyon Tanımı Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Admin Affiliate alanından müşteri ile affiliate hesabı bağlanabiliyor.",
      "Kullanılan her etiket için sabit komisyon tutarı tanımlanıp otomatik yazılabiliyor."
    ]
  },
  {
    "version": 452,
    "date": "2026-07-27",
    "title": "OTTO SKU Alanı Doğru Kaynaktan Okunup DHL Etiketine Aktarıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "OTTO siparişlerindeki SKU bilgisi doğru product.sku alanından okunup DHL etiketine aktarılıyor.",
      "Yeni OTTO etiketlerinde SKU otomatik basılıyor.",
      "Önceden üretilmiş PDF’ler kendiliğinden değişmiyor; etiket aynı takip numarasıyla yeniden üretildiğinde SKU ekleniyor."
    ]
  },
  {
    "version": 451,
    "date": "2026-07-27",
    "title": "İki Kleinpaket Etiketi Dış Sistem Kullanımı Olarak İşaretlendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "İki mevcut etiket tüketilmiş olarak kaydedildi ve müşteri bakiyesi 8’den 6’ya güncellendi.",
      "Yeni kredi veya fatura oluşturulmadı; orijinal PDF dosyaları değiştirilmedi."
    ]
  },
  {
    "version": 450,
    "date": "2026-07-26",
    "title": "Shopify Checkout Etiketleri 40 Karakter Sınırına Uyarlandı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Shopify checkout oluşturulurken 40 karakteri aşan müşteri etiketleri 422 hatasına neden oluyordu.",
      "Etiketler artık Shopify sınırına uygun üretiliyor.",
      "Normal kredi alımı ve admin manuel fatura akışları koruma altına alındı."
    ]
  },
  {
    "version": 449,
    "date": "2026-07-25",
    "title": "Manuel Etiket Ekranına Aynı Adres İçin 1–50 Etiket Oluşturma Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Manuel etiket ekranına 1 ile 50 arasında etiket adedi seçimi eklendi.",
      "Aynı adres için seçilen adet kadar ayrı etiket ve takip numarası oluşturuluyor.",
      "Yetersiz bakiye varsa işlem başlamıyor.",
      "Ürün, adet, gönderi türü ve durum metinleri Türkçe, İngilizce ve Almanca arayüzlerde seçili dile göre gösteriliyor."
    ]
  },
  {
    "version": 448,
    "date": "2026-07-24",
    "title": "İade, Ceza ve Diğer Operasyon Masrafları Cirodan Düşülecek Şekilde Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "İade, ceza, kayıp paket ve benzeri günlük masraflar kaydedilebilir hale geldi.",
      "Masraflar dönemsel cirodan otomatik düşülüyor ve gerektiğinde kayıtlar silinebiliyor."
    ]
  },
  {
    "version": 447,
    "date": "2026-07-24",
    "title": "Kullanılmış Etiket ve Bonus Ciro Hesapları Düzeltildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "İptal ve başarısız gönderiler kullanım adedinden çıkarılarak ekranlar aynı doğru sayıda birleştirildi.",
      "Bonus/telafi etiketleri fatura bedeli sıfır kalırken müşterinin tanımlı fiyatıyla kullanım cirosuna dahil edildi."
    ]
  },
  {
    "version": 446,
    "date": "2026-07-24",
    "title": "Çoklu Kredi Ekleme Atomik ve Tekrarsız Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Sepetteki tüm kredi satırları birlikte doğrulanıp tek işlemde kaydediliyor; bir satır hata verirse hiçbir satır uygulanmıyor.",
      "Sayfa yenileme veya gecikmede devam eden işlem kontrol edilerek mükerrer kredi oluşması engelleniyor."
    ]
  },
  {
    "version": 445,
    "date": "2026-07-24",
    "title": "Faturalamaya Etiket Kullanım Cirosu Raporu Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Kullanılan etiket adedi ile net, KDV ve brüt ciro günlük, haftalık, aylık, yıllık ve tüm zamanlar için gösteriliyor.",
      "Ürün bazlı adet/ciro kırılımı gerçek müşteri satış fiyatları üzerinden hesaplanıyor."
    ]
  },
  {
    "version": 444,
    "date": "2026-07-21",
    "title": "Etiket Dosya Sonuçlarına Satış Tarihi ve Üç Aylık Yeniden Yayınlama Kuralı Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "“Dosya sonuçları” tablosuna Satış tarihi sütunu eklendi.",
      "Satışın üzerinden en az 3 ay geçmiş, kullanılmamış ve DHL sonucu temiz/hareketsiz etiketler admin tarafından seçilip yeniden havuza alınabiliyor.",
      "Üç ay dolmamış veya DHL hareketi bulunan etiketler engelleniyor ve engel nedeni gösteriliyor."
    ]
  },
  {
    "version": 443,
    "date": "2026-07-21",
    "title": "eBay Takip Numarası Yeniden Kullanımına Kalıcı Koruma Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Geçmişte eBay’de kullanılmış, iptal edilmiş, void veya failed takip numaraları yeni eBay siparişlerine atanamıyor.",
      "eBay’in 201 cevabı canlı geri okuma ile doğrulanmadan başarı sayılmıyor; reddedilen işlem başarısız kalıyor."
    ]
  },
  {
    "version": 442,
    "date": "2026-07-21",
    "title": "Tekrar Kullanılmış eBay Takibi Yeni DHL Etiketiyle Değiştirildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etkilenen eBay siparişindeki eski takip emekliye ayrıldı ve yeni takip canlı eBay API’de doğrulandı.",
      "Gönderi ve sipariş başarı durumuna getirildi; müşteri bakiyesi değiştirilmedi."
    ]
  },
  {
    "version": 441,
    "date": "2026-07-20",
    "title": "Son Üç Ayda Atanmış Kullanılmamış Etiketleri Admin Onayıyla Stoğa İade Etme Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin, son üç ay içinde müşteriye atanmış ancak indirilmemiş ve kullanılmamış etiketi açık onayla havuza iade edebiliyor.",
      "Kullanılmış, dışa aktarılmış, rezerve edilmiş veya gerçek DHL hareketi bulunan kayıtlar iade kapsamı dışında tutuluyor.",
      "İade işlemi otomatik çalışmıyor; uygunluk kontrolünden sonra admin tarafından başlatılıyor."
    ]
  },
  {
    "version": 440,
    "date": "2026-07-20",
    "title": "Geçici Tarayıcı Hatalarının Yanlış Alarm E-postası Üretmesi Engellendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Timeout, DOM, sayfa yenileme ve benzeri geçici hatalar tek başına alarm oluşturmuyor.",
      "Alarm için aynı gerçek hatanın üç ardışık kontrolde sürmesi gerekiyor; düzelmiş adaylar siliniyor ve tekrar e-posta süresi uygulanıyor."
    ]
  },
  {
    "version": 439,
    "date": "2026-07-18",
    "title": "Public Sayfalardaki Boş Görseller WebP ve PNG Fallback ile Düzeltildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "“Gönderi takibi” ve “Tüm kanallarınız tek gönderi sürecinde” alanlarındaki boş görsel sorunu düzeltildi.",
      "Hatalı AVIF kullanımı kaldırıldı; uyumlu WebP ve PNG yedeğine geçildi.",
      "Almanca, İngilizce, Türkçe ve Kürtçe sayfalar kontrol edildi."
    ]
  },
  {
    "version": 438,
    "date": "2026-07-18",
    "title": "Almanca Impressum Sayfası Canlıya Alındı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Gönderilen Almanca yasal metin eksiksiz eklendi; telefon, e-posta ve web adresleri tıklanabilir hale getirildi.",
      "Mobil ekrandaki uzun başlık taşması giderildi; AGB ve Datenschutz içerikleri değiştirilmedi."
    ]
  },
  {
    "version": 437,
    "date": "2026-07-18",
    "title": "Etiket Alıcı, Firma ve Adres Satır Sırası Düzeltilip Paket Adedi Alanı Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Etikette satır sırası Alıcı, Firma ve Adres olarak düzenlendi.",
      "Uzun satırlar birleştiğinde Alıcı ve Firma sırası korunuyor.",
      "Tekli manuel formdan Paket adedi kaldırıldı; her işlem tek etiket oluşturuyor.",
      "Toplu importtaki çoklu etiket özelliği korunuyor."
    ]
  },
  {
    "version": 436,
    "date": "2026-07-18",
    "title": "Etiket Kaynaklarına Güvenli Silme ve Yeniden Yayınlama Kuralları Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Güvenli silme işlemi etiketi void durumuna geçirip satıştan çıkarıyor; müşteriye veya gönderiye bağlı ve kullanılmış etiketler silinemiyor.",
      "Yalnız uygun kayıtlar yeniden yayınlanabiliyor; süresi dolmuş PDF’ler indirilemiyor, atanamıyor, satılamıyor veya yeniden yayınlanamıyor."
    ]
  },
  {
    "version": 435,
    "date": "2026-07-18",
    "title": "Etiket Ürün Kartlarından Kayıt Detayı, Arama ve Filtre Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Bir ürün kartına tıklandığında o ürüne ait tüm etiketler listeleniyor; takip numarası, dosya ve müşteri araması ile durum filtreleri kullanılabiliyor.",
      "Yeni etiket ekleme ekranı seçilen ürün önceden doldurulmuş olarak açılıyor."
    ]
  },
  {
    "version": 434,
    "date": "2026-07-18",
    "title": "Süresi Dolmuş PDF Etiketlerinin İndirme, Atama ve Satışı Sistem Genelinde Engellendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "PDF’nin içindeki gerçek süre kuralına göre dolmuş etiketler “Süresi bitmiş” durumuna taşınıyor.",
      "Süresi dolmuş veya doğrulanamayan PDF; indirme, satın alma, admin/toplu atama, değiştirme ve yedek etiket seçiminde kullanılamıyor.",
      "Aynı süresi bitmiş PDF yeniden yayınlanamıyor; geçerli yeni PDF yüklenmesi gerekiyor."
    ]
  },
  {
    "version": 433,
    "date": "2026-07-18",
    "title": "DHL Kontrol Sunucusundaki Process Sızıntısı ve Kapasite Sınırları Düzeltildi",
    "confidence": "operational",
    "audience": [
      "system"
    ],
    "items": [
      "DHL kontrol sunucusundaki birikmiş Playwright süreçleri temizlenip süreç sızıntısı giderildi.",
      "Dosya limiti yükseltildi; paralellik ve dakikalık kontrol hızı sunucu kapasitesine göre sınırlandı.",
      "DHL yanıt bekleme ve resmi DHL fallback akışı düzeltildi; 404 hareket yok sayılmıyor.",
      "SQLite kayıt hatasının başarılı sorguyu 500’e çevirmesi engellendi."
    ]
  },
  {
    "version": 432,
    "date": "2026-07-18",
    "title": "Karantinadaki 20 kg Etiketler Seçilebilir Hale Getirilip Eski DHL Durumları Temizlendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Üç aylık süreyi geçen ve DHL sonucu temiz olan beş adet 20 kg etiket admin seçiminde yeniden yayınlanabilir hale getirildi.",
      "Başarısız DHL sorgularında eski İade edildi veya Şubede bekliyor sonuçlarının terminal durum olarak gösterilmesi kaldırıldı.",
      "1.632 yanıltıcı kayıt temizlenip yeniden kontrol kuyruğuna alındı.",
      "Otomatik yeniden yayınlama yapılmadan admin onayı şartı korundu."
    ]
  },
  {
    "version": 431,
    "date": "2026-07-17",
    "title": "Otomatik Altı Aylık PDF Karantinası Kaldırılıp Kullanım Kanıtı Kuralına Geçildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "PDF `CreationDate + 6 ay` otomatik karantina kuralı tamamen kaldırıldı.",
      "Son 5 ayda müşteriye atanmış veya dışa aktarılmış etiketler havuza alınamıyor.",
      "Eski etiketler yalnız admin seçimiyle, DHL sonucu `clean/offen` ve gerçek hareket yoksa yeniden yayınlanabiliyor."
    ]
  },
  {
    "version": 430,
    "date": "2026-07-17",
    "title": "DHL Hareket Kanıtına Dayalı İptal Kuralı Tüm Müşterilere Uygulandı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Open/hareketsiz gönderiler iptal edilebilir; gerçek transit, teslim, iade veya event kanıtı bulunanlar engellenir.",
      "DHL sorgusu başarısız olduğunda kayıtlı hareket kanıtı yoksa iptal gereksiz yere bloklanmıyor ve karar audit’e yazılıyor."
    ]
  },
  {
    "version": 429,
    "date": "2026-07-17",
    "title": "Süresi Bitmiş Etiketleri Admin Seçimiyle Yeniden Yayınlama Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Admin, Süresi Bitmiş Etiketler ekranında uygun etiketleri seçip tek işlemde ortak stoğa yeniden yayınlayabiliyor.",
      "Tek seferde 90 etikete kadar yeniden yayınlama destekleniyor.",
      "Eski müşteri, kullanım ve satın alma ilişkileri denetim geçmişine alınırken bakiyeler yeniden hesaplanıyor ve etikete yeni geçerlilik süresi veriliyor.",
      "Yeniden yayınlama yalnız açık admin onayıyla yapılıyor."
    ]
  },
  {
    "version": 428,
    "date": "2026-07-17",
    "title": "Üç Müşteri Gönderisi Güvenle İptal Edilip Kredileri Geri Verildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "DHL’de hareket olmadığı doğrulanan üç gönderi iptal edildi ve etiketler yeniden kullanılabilir hale getirildi.",
      "Müşterinin Kleinpaket bakiyesi 194’ten 197’ye yükseltildi ve audit kayıtları oluşturuldu."
    ]
  },
  {
    "version": 427,
    "date": "2026-07-07",
    "title": "Eski Shopify Faturalarında Net ve Brüt Tutar Yorumu Tarihe Göre Düzeltildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Eski Shopify ve admin satın alma kayıtlarında total_price alanının net veya brüt anlamı kayıt tarihine göre ayrıştırıldı.",
      "5 Haziran 2026 öncesi admin_recent kayıtlarında çekilen tutar brüt kabul edilip KDV içinden ayrılıyor.",
      "Sonraki veya net, KDV ve brüt bilgisi açık kayıtların mevcut hesapları korunuyor.",
      "Etkilenen faturalar düzeltilmiş PDF ve ZIP olarak yeniden üretildi."
    ]
  },
  {
    "version": 426,
    "date": "2026-07-05",
    "title": "Başarılı Toplu Etiket Sonrası Yanlış Kredi Uyarısı Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Başarıyla oluşturulan veya atlanan siparişler işlem modalından çıkarılıyor.",
      "Yalnız hata kalan satırlar gösterildiği için tamamlanmış işlemden sonra sahte “kredi yetersiz” uyarısı oluşmuyor."
    ]
  },
  {
    "version": 425,
    "date": "2026-07-05",
    "title": "Yüklenen Etiketlerin Pending Nedeniyle Satışa Kapanması Düzeltildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin yüklemeleri taşıyıcı kontrolünde pending yerine satın alınabilir unchecked stok durumuyla başlıyor.",
      "Pending kaldığı için görünmeyen 245 canlı etiket yeniden açıldı.",
      "Kleinpaket ve diğer küçük pending stoklar satın alma ekranında tekrar kullanılabilir hale geldi."
    ]
  },
  {
    "version": 424,
    "date": "2026-07-03",
    "title": "Shopify Bağlantısında Orders Scope Onayı Kaydetmeden Önce Doğrulanır Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Shopify mağazası kaydedilmeden önce token ile Orders API izin testi yapılıyor.",
      "read_orders onayı yoksa bağlantı başarılı kabul edilmiyor ve anlaşılır yeniden yetkilendirme hatası gösteriliyor.",
      "Senkron sırasında izin hatasında token bir kez yenileniyor; devam ederse otomatik senkron duraklatılıyor.",
      "Mevcut hatalı mağaza hata döngüsünden çıkarılıp izin yeniden onayı bekleyecek duruma alındı."
    ]
  },
  {
    "version": 423,
    "date": "2026-07-03",
    "title": "Bozuk Shopify Credential Kaydı Canlıda Onarıldı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Bozuk canlı Shopify credential kaydı geçerli access token ile onarıldı.",
      "Client ID, Client Secret, token süresi ve senkron durumu yeniden hizalandı; eski bağlantı hatası temizlendi.",
      "Diğer Shopify bağlantıları taranarak aynı yanlış alan bozulmasının başka kayıtlarda kalmadığı doğrulandı."
    ]
  },
  {
    "version": 422,
    "date": "2026-07-03",
    "title": "Shopify Mağaza Güncellemesinde Client Secret Tokena Güvenle Çevrilir Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Mevcut Shopify mağazası düzenlenirken Client Secret değeri access token alanına doğrudan yazılmıyor; Client ID ile geçerli tokena çevriliyor.",
      "Önceden yanlış alana kaydedilmiş secret değerleri, Client ID sağlandığında kendini onaracak şekilde güncelleme akışına koruma eklendi."
    ]
  },
  {
    "version": 421,
    "date": "2026-07-02",
    "title": "Başarısız Gönderi İptal Denemeleri Uygulama Hata Loglarına Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Başarısız müşteri ve admin gönderi iptal denemeleri app error loglarına shipment_cancel kategorisiyle yazılmaya başlandı.",
      "Başarısız denemenin nedeni ve işlem bağlamı destek ekiplerinin doğrudan inceleyebileceği şekilde kaydediliyor.",
      "DHL open ve fiziksel hareketi olmayan used kayıtların iptaline izin veren mevcut güvenlik kuralı korunuyor."
    ]
  },
  {
    "version": 420,
    "date": "2026-07-02",
    "title": "Geçici Depolama Hataları İçin Güvenli Bakım Retry Kapsamı Genişletildi",
    "confidence": "operational",
    "audience": [
      "system"
    ],
    "items": [
      "Kredisi daha önce iade edilmiş ve aynı siparişte başarılı yedeği olmayan geçici S3 hata kayıtları güvenli retry’a alındı.",
      "On beş etiketin tamamı yeniden üretildi; başarısız veya bekleyen aday bırakılmadı.",
      "Bakım akışı 503 yanında 504, 520, timeout ve ağ kopması hatalarını da kapsıyor.",
      "Retry yalnız kredisi iade edilmiş ve başarılı yedeği bulunmayan kayıtlarda çalışıyor."
    ]
  },
  {
    "version": 419,
    "date": "2026-07-02",
    "title": "Cache Busting ve Eski Asset Uyumluluğu Kalıcı Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "JS/CSS URL’lerine sürüm sorgusu eklenerek yeni deployların güvenli biçimde alınması sağlandı.",
      "Eski HTML kullanan tarayıcılar için önceki assetler geçici uyumluluk katmanında tutuldu."
    ]
  },
  {
    "version": 418,
    "date": "2026-07-02",
    "title": "Frontend Asset Adları Sabitlenerek Beyaz Ekran Riski Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Her dağıtımda değişen asset adları yerine sabit JavaScript ve CSS giriş dosyaları kullanılmaya başlandı.",
      "Asset dosyaları için yanlış immutable cache davranışı kaldırıldı."
    ]
  },
  {
    "version": 417,
    "date": "2026-07-02",
    "title": "Eski HTML Kullanan Tarayıcılar İçin Asset Uyumluluk Katmanı Eklendi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Son dağıtımlardaki eski JS/CSS dosyaları canlı pakete eklenerek beyaz ekran cache temizliği gerektirmeden giderildi.",
      "Cloudflare cache temizlendi ve eski asset isteklerinin doğru JavaScript/CSS içerik türüyle döndüğü doğrulandı."
    ]
  },
  {
    "version": 416,
    "date": "2026-07-02",
    "title": "Depolama Hatasıyla Yarım Kalan Etiketler Güvenle Yeniden İşlendi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Geçici S3 hatasıyla yarım kalan güvenli adaylar canlıda yeniden oluşturuldu.",
      "Başarısız aday kuyruğu sıfıra indirildi ve müşteri bakiyelerinin korunması doğrulandı."
    ]
  },
  {
    "version": 415,
    "date": "2026-07-02",
    "title": "S3 Etiket Üretimine Retry, Timeout ve Düşük Paralellik Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "S3 GET/PUT işlemlerine kontrollü yeniden deneme ve zaman aşımı eklendi.",
      "Toplu etiket üretiminin depolamayı aşırı yüklememesi için eşzamanlılık düşürüldü ve teknik hata metinleri sadeleştirildi."
    ]
  },
  {
    "version": 414,
    "date": "2026-07-02",
    "title": "Stylesiz Açılan Canlı Arayüz İçin Acil Rollback Tamamlandı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Canlı uygulama son sağlam sürüme geri alındı ve CSS dosyalarının yeniden doğru yüklendiği doğrulandı.",
      "Riskli sistem durumu değişikliği müşterileri etkilemeden geri çekildi."
    ]
  },
  {
    "version": 413,
    "date": "2026-07-01",
    "title": "Shopify Client Secret Değerinin Access Token Gibi Kaydedilmesi Engellendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Shopify Client Secret değerinin doğrudan access token alanına kaydedilmesi engellendi.",
      "Client Secret, Client ID ile geçerli Admin API tokenına çevrilerek doğru credential alanlarına yazılıyor.",
      "Hatalı veya eksik bağlantılarda ham 401 mesajı yerine yeniden bağlantıyı açıklayan kullanıcı dostu hata gösteriliyor.",
      "Aynı credential koruması sipariş senkronu ile tracking ve fulfillment yazma akışlarına uygulandı."
    ]
  },
  {
    "version": 412,
    "date": "2026-07-01",
    "title": "DHL Open Olan Used Etiketlerin İptal Edilememesi Düzeltildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "DHL open veya pre-transit ve event bulunmayan kayıtların yalnız carrier-check used durumuna bakılarak hareketli sayılması engellendi.",
      "DHL açık ve hareketsizse iptal ile kredi iadesine izin veriliyor; gerçek transit, teslim veya event kanıtında engel korunuyor.",
      "İki canlı etiket başarıyla iptal edilip müşteri stokuna geri döndü."
    ]
  },
  {
    "version": 411,
    "date": "2026-06-26",
    "title": "Admin İptal Akışı ve İşlem Günlükleri Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin gönderiler ekranındaki iptal butonunun admin modunda çalışmaması düzeltildi.",
      "İptal sonrası etiketin geri verilmesi, siparişin açılması ve bakiyenin senkronlanması korundu; taşıyıcı hareketi varsa iptal engeli sürdürüldü.",
      "Sayfa görüntüleme, tekli ve toplu etiket oluşturma ile müşteri ve admin iptalleri için ayrıntılı işlem günlüğü eklendi."
    ]
  },
  {
    "version": 410,
    "date": "2026-06-26",
    "title": "Ağırlığı Olmayan JTL Siparişlerinde Otomatik Kleinpaket Seçimi Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Ağırlığı sıfır veya eksik JTL siparişlerinde otomatik Kleinpaket seçimi kaldırıldı.",
      "Kullanıcıdan manuel etiket ürünü seçmesi isteniyor.",
      "Uyarı Türkçe, İngilizce ve Almanca dillerine eklendi."
    ]
  },
  {
    "version": 409,
    "date": "2026-06-26",
    "title": "Gönderi İptaline DHL Hareket Güvenliği ve Sipariş Ekranı Aksiyonu Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Gönderi iptali öncesine DHL ve carrier hareket kontrolü eklendi.",
      "Yalnız open veya Status offen ve hareket kanıtı olmayan etiketler iptal edilip krediye dönebiliyor; yolda, teslim, iade, problem veya check-error durumları engelleniyor.",
      "Sipariş satırlarına İptal aksiyonu eklendi; toplu seçim aynı güvenlik kuralını kullanıyor.",
      "Bakiye merkezi label-source hesaplamasıyla yeniden senkronlanıyor."
    ]
  },
  {
    "version": 408,
    "date": "2026-06-26",
    "title": "Admin ve Müşteri Panelindeki Eksik Türkçe, İngilizce ve Almanca Çeviriler Tamamlandı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin ve müşteri panelindeki eksik Türkçe, İngilizce ve Almanca çeviri anahtarları tamamlandı.",
      "Hatalı Etiketler başlıkları, kartları, tablosu, durumları ve aksiyonları seçili dile bağlandı.",
      "Sidebar etiket alanları, giriş footer bağlantıları ve tarayıcı başlığı da dile göre değişiyor."
    ]
  },
  {
    "version": 407,
    "date": "2026-06-25",
    "title": "Çelişkili Open ve In-Transit Etiket Durumları Canlıda Onarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "DHL’de yalnız ön bildirim veya open görünen ancak veritabanında void veya in-transit kalan çelişkili kayıtlar tespit edildi.",
      "Müşteriye atanmamış, tüketilmemiş ve dış kullanım görmemiş 47 etiket available, clean ve open durumuna geri alındı.",
      "Müşteriye atanmış veya telafi edilmiş 35 kayıt çift kredi riski nedeniyle otomatik değiştirilmedi.",
      "Paketankündigung ve announced-only durumlarının open sayılması için kalıcı kural eklendi."
    ]
  },
  {
    "version": 406,
    "date": "2026-06-25",
    "title": "Hatalı Etiket PDF’leri İçin Toplu ZIP Dışa Aktarımı Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hatalı Etiketler ekranına PDF ZIP aksiyonu eklendi.",
      "PDF anahtarı bulunan tüm void etiketler tek arşivde indirilebiliyor.",
      "Yüzlerce dosyada bellek taşmasını azaltmak için PDF’ler tek tek stream edilerek ZIP oluşturuluyor.",
      "İndirme endpoint’i admin yetkisiyle korunuyor."
    ]
  },
  {
    "version": 405,
    "date": "2026-06-25",
    "title": "Hatalı Etiket CSV Dışa Aktarımı Tüm Kayıtları ve Audit Alanlarını Kapsadı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "CSV dışa aktarımı sayfa limiti yerine tüm void kayıtları kapsayacak şekilde genişletildi.",
      "ID, takip, ürün, ağırlık, müşteri, PDF veya R2, carrier ve DHL durumu, son event, telafi, shipment, dış kullanım ve tarih alanları eklendi.",
      "Canlı envanterdeki tüm hatalı kayıtların tek dosyada dışa aktarılması sağlandı."
    ]
  },
  {
    "version": 404,
    "date": "2026-06-25",
    "title": "JTL Adres Ek Satırı ve Sipariş Ağırlığı Fallback’i Düzeltildi",
    "confidence": "implemented",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Teslimat adresi mevcut olduğunda eski adres defterindeki ikinci satırın yeni gönderi adresine karışması engellendi; normal adreslerdeki yanlış ek satırlar temizlenirken Packstation, Postfiliale ve Paketshop adresleri korundu.",
      "Ürün ağırlığı eksikse pozitif sipariş ağırlığı yedek olarak kullanılıyor; güvenli açık kayıt canlı veride yedek alınarak onarıldı."
    ]
  },
  {
    "version": 403,
    "date": "2026-06-25",
    "title": "Admin Hatalı Etiket Detayına Güvenli Kullanıma Aç İşlemi Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Hatalı etiket detayına Kullanıma aç aksiyonu eklendi.",
      "Aksiyon etiketi admin stok havuzunda available duruma getiriyor.",
      "Eski müşteri ataması varsa bakiyeler yeniden senkronlanarak çift kredi riski azaltılıyor."
    ]
  },
  {
    "version": 402,
    "date": "2026-06-25",
    "title": "Hatalı Etiket Takip Numaraları DHL Sayfasına Linklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hatalı veya void etiket takip numaraları DHL takip sayfasını yeni sekmede açan bağlantılara dönüştürüldü.",
      "Aynı bağlantı tablo satırında ve detay panelinde kullanılabiliyor."
    ]
  },
  {
    "version": 401,
    "date": "2026-06-25",
    "title": "Bir Müşteri İçin 294 Kleinpaket Etiketi Yeniden Kullanıma Açıldı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Temiz ve DHL open durumundaki etiketler müşteriye yeniden atandı.",
      "Kleinpaket bakiyesi sıfırdan 294’e getirildi ve aynı koşulda hatalı kayıt kalmadı."
    ]
  },
  {
    "version": 400,
    "date": "2026-06-25",
    "title": "Yanlış Void Edilen 4.847 Açık DHL Etiketi Güvenle Geri Kazandırıldı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "DHL’de hareket göstermeyen açık etiketler stok veya mevcut müşteri atamasına geri döndürüldü.",
      "Yedek verilmiş kayıtlar korunarak çift kredi önlendi ve ilgili bakiyeler yeniden eşitlendi."
    ]
  },
  {
    "version": 399,
    "date": "2026-06-25",
    "title": "Hatalı Etiketler DHL Gerçek Durumuna Göre Ayrı Kategorilere Bölündü",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hatalı Etiketler ekranına Status offen, Teslim edildi, Yolda ve Diğer kategorileri eklendi.",
      "Kategoriler ayrı özet kartları ve filtreler olarak kullanılabiliyor.",
      "Canlı void envanteri DHL durumuna göre yeniden sayıldı; açık bildirimli kayıtlar teslim edilmiş ve hareketli etiketlerden ayrıldı."
    ]
  },
  {
    "version": 398,
    "date": "2026-06-25",
    "title": "Admin Etiket Yükleme Sayfasına Canlı İşlem Günlüğü Eklendi",
    "confidence": "verified",
    "audience": [
      "admin"
    ],
    "items": [
      "Admin etiket yükleme ekranına başlatma, yükleme, kaydetme, atlama, hata, retry ve final özet olaylarını gösteren canlı işlem günlüğü eklendi.",
      "Aynı takip numarası ön kontrolde veya backend’de yakalandığında ikinci kayıt oluşturulmadan atlanıyor.",
      "Başarılı yüklemeler available ve clean stok durumunda kaydediliyor."
    ]
  },
  {
    "version": 397,
    "date": "2026-06-25",
    "title": "PDF Form Alanı Olmayan Etiketler İçin Yükleme Parser’ı Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Etiket yükleme parser’ı form alanı bulunmayan ve sıkıştırılmış stream kullanan PDF’lerden takip numarası okuyacak şekilde güçlendirildi.",
      "Sendungsnr, Sendungsnummer ve Identcode alanları ile 2 kg veya 5 kg gibi ağırlık bilgileri daha güvenilir çıkarılıyor.",
      "Dosya adındaki takip numarası PDF içeriğiyle uyuşmazsa yükleme güvenli biçimde durduruluyor.",
      "Mevcut mükerrer kontrol, kuyruk, paralel yükleme, durdurma ve retry davranışları korundu."
    ]
  },
  {
    "version": 396,
    "date": "2026-06-25",
    "title": "Amazon Bridge Global Kilidi ve Otomatik Senkron Aralığı Güvenli Hale Getirildi",
    "confidence": "operational",
    "audience": [
      "system"
    ],
    "items": [
      "Amazon bağlantı otomasyonu ile sipariş senkronunun aynı global kilidi uzun süre tutması engellendi.",
      "Otomatik senkron 15 dakikalık aralık ve iki dakikalık işlem bütçesiyle sınırlandı.",
      "Bridge yeniden başlatıldı; health ve bağlantı başlatma uçlarının meşgul olmadan yanıt verdiği doğrulandı."
    ]
  },
  {
    "version": 395,
    "date": "2026-06-25",
    "title": "Billbee Alt Mağaza Kimliği ve Satış Kanalı Filtreleri Geri Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Billbee alt mağaza kimliği, adı ve satış kanalı alanları yeniden içe aktarılıyor.",
      "D1’e alt mağaza ve satış kanalı kolonları eklendi; eski kayıtlar S3 önbelleğinden geriye dolduruluyor.",
      "Sipariş ekranına yalnız Billbee mağazalarında görünen alt mağaza filtresi eklendi; liste, sayım, sayfalama ve CSV ile uyumlu çalışıyor.",
      "Sipariş satırında alt mağaza ve satış kanalı gösteriliyor."
    ]
  },
  {
    "version": 394,
    "date": "2026-06-25",
    "title": "DHL Open ve Pre-Transit Etiketlerin Yanlış Void Edilmesi Düzeltildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "DHL pre-transit, Paketankündigung ve Status offen durumları temiz ve kullanılmamış etiket olarak sınıflandırılıyor.",
      "Bu durumların yanlışlıkla used veya void sayılması engellendi.",
      "Canlıdaki 53 adet 2 kg etiket available ve clean durumuna geri alındı; aynı desende hata bırakılmadı."
    ]
  },
  {
    "version": 393,
    "date": "2026-06-21",
    "title": "Packstation ve Postfiliale Siparişlerinde Tekli Etiket Oluşturma Korundu",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Packstation ve Postfiliale siparişleri toplu etiket seçiminden çıkarılmaya devam ediyor.",
      "Packstation ve Postfiliale siparişleri satırdaki tekli Etiket aksiyonuyla ayrı ayrı oluşturulup PDF olarak indirilebiliyor.",
      "Postnummer ile Packstation veya Postfiliale satırları PDF’te doğru ayrıştırılıyor ve özel routing kodları destekleniyor."
    ]
  },
  {
    "version": 392,
    "date": "2026-06-21",
    "title": "Packstation ve Postfiliale Siparişleri Toplu Etiket Seçiminden Çıkarıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Packstation ve Postfiliale adresli siparişler toplu etiket seçiminde pasif hale getirildi.",
      "Sayfadaki gönderileri seç işlemi bu özel adresli siparişleri otomatik atlıyor.",
      "Satırda özel adres uyarısı ve engel nedeni gösteriliyor; tekli etiket akışı ayrı olarak kullanılabiliyor."
    ]
  },
  {
    "version": 391,
    "date": "2026-06-21",
    "title": "Müşteri Hesabındaki Fazla eBay ve Kaufland Mağazaları Temizlendi",
    "confidence": "operational",
    "audience": [
      "customer"
    ],
    "items": [
      "Müşteri hesabındaki mükerrer eBay bağlantıları geçmiş sipariş ve etiketleri korumak için pasifleştirildi; yalnız ana eBay bağlantısı aktif bırakıldı.",
      "Boş ve pasif Kaufland placeholder kaydı kaldırıldı; doğru Kaufland bağlantısı korundu.",
      "Müşteri mağaza API’si pasif veya arşivlenmiş kayıtları varsayılan listeden gizliyor."
    ]
  },
  {
    "version": 390,
    "date": "2026-06-19",
    "title": "DHL Carrier Cron’u Doğru Secret Ortamındaki Pages Endpoint’ine Taşındı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "DHL carrier cron, DHL secret’larının bulunduğu Pages endpoint’i üzerinden çalışacak şekilde yönlendirildi.",
      "Eksik yapılandırma nedeniyle güncellenmeyen takip sonuçları tekrar kontrol edilebilir hale getirildi.",
      "Tek takip numarası için canlı carrier-check aksiyonu eklendi.",
      "Status offen ve yalnız elektronik bildirim bulunan kayıtlar fiziksel hareket yok olarak gösteriliyor."
    ]
  },
  {
    "version": 389,
    "date": "2026-06-19",
    "title": "WooCommerce Siparişlerine Takip Numarası Geri Yazma Desteği Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "WooCommerce kaynak platform takip senkronu etkinleştirildi.",
      "Etiket takip bilgisi WooCommerce sipariş metadata’sına yazılıyor.",
      "Canlı örnek gönderide senkron success olarak doğrulandı; DHL hareketi taşıyıcı taramasına bağlı kalıyor."
    ]
  },
  {
    "version": 388,
    "date": "2026-06-19",
    "title": "Shopify Satın Alma ve Fatura Kayıtları Canlıda Doğrulanıp Onarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiket satın alma faturaları ürün bazında parçalı satırlar yerine tek hizmet satırı ve 1 Stück olarak gösteriliyor.",
      "Mevcut net, MwSt ve brüt toplamlar korunurken yalnız fatura sunumu ve PDF düzeni değiştirildi.",
      "Canlıdaki etkilenen fatura yeniden üretilip yeni tek satırlı biçimde doğrulandı."
    ]
  },
  {
    "version": 387,
    "date": "2026-06-19",
    "title": "eBay Yeniden Bağlamada Mükerrer Mağaza Oluşması Engellendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Aynı eBay kullanıcı kimliği yeniden bağlandığında yeni mağaza kaydı açmak yerine mevcut mağaza yeniden kullanılıyor.",
      "Canlıdaki mükerrer bağlantılar güvenli temizlik için ayrıştırıldı; ana eBay ve doğru Kaufland bağlantılarının korunması sağlandı."
    ]
  },
  {
    "version": 386,
    "date": "2026-06-18",
    "title": "İptal Edilebilir Gönderi Yoksa Toplu Seçim Kontrolü Pasif Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Sayfada iptal edilebilir gönderi yoksa Sayfadaki gönderileri seç kontrolü pasif hale geliyor.",
      "İptal edilmiş satırlar yeniden seçilemiyor ve pasif checkbox üzerinde nedenini açıklayan yardım metni gösteriliyor.",
      "Kredisi daha önce iade edilmiş bir gönderinin tekrar iptal edilmesi engelleniyor."
    ]
  },
  {
    "version": 385,
    "date": "2026-06-18",
    "title": "Eski Amazon Siparişleri Aktif Gönderilmemiş Listesinden Arşivlendi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Geçmiş senkronla gelen eski açık siparişler silinmeden arşive taşındı.",
      "Aktif “Sadece gönderilmemiş” listesinde yalnız güncel açık sipariş bırakıldı."
    ]
  },
  {
    "version": 384,
    "date": "2026-06-18",
    "title": "Mükerrer Etiketlerden Doğru Olan Korunup Yanlış Olanlar İptal Edildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Mükerrer gönderi grubunda doğru basılmış etiket korundu, iki yanlış kayıt iptal edildi ve ilgili ürün kredileri müşteriye geri döndü.",
      "İptal edilen gönderilerde teknik tracking prefix’i müşteri ekranından temizlendi ve DHL aktif takip bağlantısı gösterilmesi engellendi."
    ]
  },
  {
    "version": 383,
    "date": "2026-06-18",
    "title": "Kaynak Shopify İçinde Salt Okunur Sipariş Arama Endpoint’i Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Admin-only kaynak sipariş arama endpoint’i Shopify sipariş geçmişini içe aktarma veya veri yazma yapmadan tarıyor.",
      "Eksik görünen siparişlerin KenPost cache’inden mi yoksa kaynak Shopify feed’inden mi kaynaklandığı güvenli biçimde ayrıştırılabiliyor."
    ]
  },
  {
    "version": 382,
    "date": "2026-06-18",
    "title": "Amazon Cron’u Doğru Secret Ortamındaki Pages Endpoint’ine Taşındı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Amazon otomatik senkron cron’u gerekli kaynak Shopify secret’larının bulunduğu Pages endpoint’i üzerinden çalıştırılmaya başlandı.",
      "Aktif Amazon mağazaları 30 günlük aralıkla yeniden senkronlandı; yeni ve güncellenen siparişler D1’e işlendi.",
      "Zamanlanmış çalışmanın hata vermeden tamamlandığı doğrulandı."
    ]
  },
  {
    "version": 381,
    "date": "2026-06-18",
    "title": "Mağaza Bazlı Gönderici Adresiyle 37 Etiket Yeniden Üretildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Üç mağazanın etiketleri canlı API üzerinden doğru mağaza gönderici adıyla yeniden oluşturuldu.",
      "Yeni PDF’lerde mağazalar arası yanlış gönderici adı karışmasının kalmadığı doğrulandı."
    ]
  },
  {
    "version": 380,
    "date": "2026-06-18",
    "title": "Genel Adresten Mağaza Adresi Devralmada Gönderici Adı Karışması Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Genel adresten mağaza adresi devralınırken gönderici adının global profilden kopyalanması engellendi.",
      "Adres genel profilden, gönderici adı ise ilgili mağaza adından alınacak şekilde form düzeltildi.",
      "Etkilenen mağazaların özel gönderici adresleri oluşturuldu ve 25 mevcut etiket doğru mağaza adıyla yeniden üretildi."
    ]
  },
  {
    "version": 379,
    "date": "2026-06-17",
    "title": "Ortak Stoktaki DHL Etiketlerinin Tamamı Sağlık Kontrolünden Geçirildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Müşteriye atanmamış stok etiketleri open/hareketsiz olarak doğrulandı.",
      "Hatalı, hareketli veya geçersiz aktif stok kaydı kalmadığı teyit edildi."
    ]
  },
  {
    "version": 378,
    "date": "2026-06-17",
    "title": "Atanmış Kullanılmamış Etiketler Taranıp Hatalılar Değiştirildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Binlerce atanmış kullanılmamış etiket kontrol edildi; DHL hareketi bulunan hatalı etiketler void edildi.",
      "Hatalı etiketlerin tamamı temiz yedeklerle değiştirildi ve eksik telafi kalmadı."
    ]
  },
  {
    "version": 377,
    "date": "2026-06-17",
    "title": "Kullanılmış DHL Etiketleri Üç Net Duruma Normalize Edildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Tüm consumed DHL etiketleri yalnızca open, delivered veya in_transit durumlarına dönüştürüldü.",
      "Canlı veride error, pending, unchecked ve belirsiz teknik durum bırakılmadığı doğrulandı."
    ]
  },
  {
    "version": 376,
    "date": "2026-06-17",
    "title": "Eksik Shopify Etiket Kredisi Canlıda Uzlaştırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Ödenmiş ancak bakiyeye düşmemiş bir Shopify siparişi uzlaştırılarak 21 Kleinpaket ve 10 adet 2 kg kredi eklendi.",
      "Son 14 gündeki tüm Shopify billing ödemeleri yeniden tarandı; bekleyen veya atlanan kayıt bırakılmadı.",
      "Shopify ödeme uzlaştırması Cloudflare cron Worker’a bağlanarak beş dakikada bir çalışır hale getirildi."
    ]
  },
  {
    "version": 375,
    "date": "2026-06-17",
    "title": "Zamanlanmış Senkronlar GitHub Actions’tan Cloudflare Worker’a Taşındı",
    "confidence": "implemented",
    "audience": [
      "system"
    ],
    "items": [
      "Sipariş senkronu ve carrier-check zamanlamaları GitHub Actions yerine Cloudflare Cron Worker içinde çalışacak şekilde uygulandı.",
      "Worker mevcut senkron ve carrier-check yardımcılarını D1 binding üzerinden çağırıyor; manuel tetiklemeler secret ile korunuyor.",
      "Eski GitHub workflow ve schedule izleri kaldırıldı; Worker yapılandırması proje kapsamına eklendi."
    ]
  },
  {
    "version": 374,
    "date": "2026-06-16",
    "title": "Cache Kaynaklı Stylesiz Arayüz İçin Acil CSS Hotfix Dağıtıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Yeni CSS asset hash’i üretilerek canlı HTML güncel dosyaya bağlandı.",
      "Edge veya tarayıcı önbelleğinde kalan eski stylesheet nedeniyle oluşan stylesiz görünüm giderildi.",
      "Yeni CSS dosyasının doğru içerikle yüklendiği ve temel stillerin uygulandığı doğrulandı."
    ]
  },
  {
    "version": 373,
    "date": "2026-06-16",
    "title": "Mağaza Gönderici Adresi Ekranı Yalnız Gerektiğinde Düzenlenir Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Mağaza gönderici adresi bölümü varsayılan olarak kullanılan adresi gösteren salt okunur bir özet haline getirildi.",
      "Özel adres formu yalnız kullanıcı Bu mağaza için farklı adres kullan aksiyonunu seçtiğinde açılıyor.",
      "Genel adresi forma kopyalama yardımcı aksiyonu yalnız düzenleme sırasında gösteriliyor; kaydetmeden mevcut adres değişmiyor."
    ]
  },
  {
    "version": 372,
    "date": "2026-06-16",
    "title": "Mağaza Bazlı Gönderici Adresi Yönetimi ve Resolver Altyapısı Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Yanlış müşteri ve sipariş Gönderi adresleri paneli kaldırıldı.",
      "Mağaza detayına mağazaya özel gönderici adresi yönetimi eklendi.",
      "Etiket üretimi önce mağaza özel adresini, yoksa profil genel adresini kullanıyor; normal, toplu ve yeniden üretim akışları ortak resolver’a bağlandı.",
      "İade yönü korunurken manuel etiketler genel profil adresini kullanmaya devam ediyor."
    ]
  },
  {
    "version": 371,
    "date": "2026-06-16",
    "title": "Etsy Mağaza Profilleri ve Periyodik Senkron Durumu Onarıldı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "İki Etsy mağazasının canlı browser profilleri yeniden çalışır hale getirilip siparişleri senkronlandı.",
      "Profil bulunmayan mağaza yanlış hesaba bağlanmadan açıkça ayrıştırıldı; cron kimlik bilgileri eşitlendi."
    ]
  },
  {
    "version": 370,
    "date": "2026-06-16",
    "title": "Hazır Olmayan Etsy Mağazaları Toplu Senkron Hatası Yerine Atlandı Olarak Gösterildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Bağlantı profili veya aktif oturumu hazır olmayan Etsy mağazaları Tüm mağazaları senkronla sonucunda hata sayılmıyor.",
      "Sonuç modalı başarılı, hatalı ve atlanan mağazaları; atlananlarda gerekçeyi ayrı gösteriyor."
    ]
  },
  {
    "version": 369,
    "date": "2026-06-16",
    "title": "Etsy Hesap Modeli Kullanıcı, Parola, Profil ve Port Bilgileriyle Yenilendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etsy bağlantısı Shopify veya Salestio akışından ayrılarak tarayıcı profili ve Etsy hesap bilgileriyle çalışan bağımsız modele geçirildi.",
      "Etsy sipariş senkronu bridge üzerindeki tarayıcı JSON kaynağından güvenli API üzerinden okunacak şekilde uygulandı.",
      "Doğrulanmış iki Etsy mağazasının siparişleri senkronlandı; kimliği belirsiz üçüncü profil yanlış veri yazmamak için bağlanmadı."
    ]
  },
  {
    "version": 368,
    "date": "2026-06-15",
    "title": "Admin Müşteri Satın Alma Tablosuna Tarih ve Saat Sütunu Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Admin müşteri detayındaki Etiket satın almaları tablosuna Tarih sütunu eklendi.",
      "Satın alma zamanı kayıt tarihinden alınarak tarih ve saat birlikte gösteriliyor."
    ]
  },
  {
    "version": 367,
    "date": "2026-06-15",
    "title": "Geçici DHL Timeout Hataları Kalıcı Check Error Yerine Retry Kuyruğuna Alındı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "DHL timeout, ağ kopması ve browser crash gibi geçici kontrol hataları kalıcı check error yerine pending retry durumuna alınıyor.",
      "Kalıcı kontrol hataları ile geçici DHL uyarıları arayüzde ayrı kategorilerde gösteriliyor.",
      "Kontrol yükü daha küçük batch ve düşük paralellikle sınırlandı; geçici kayıtlar belirli aralıkla otomatik yeniden deneniyor.",
      "Eski geçici hata kayıtları temizlenerek kalıcı error sayısı sıfırlandı."
    ]
  },
  {
    "version": 366,
    "date": "2026-06-15",
    "title": "Etsy Yetkilendirme Linki Bridge Üzerinde Anında Yayınlanır Hale Getirildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etsy URL algılama daha erken tarayıcı hedeflerinden yakalanacak şekilde düzeltildi.",
      "Bridge servisi yeniden başlatıldı ve yetkilendirme linkinin saniyenin altında yayınlandığı doğrulandı."
    ]
  },
  {
    "version": 365,
    "date": "2026-06-14",
    "title": "Etiket Kontrollerine Kritik Operasyon Özeti ve Olumsuz Kayıt Tablosu Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Etiket Kontrolleri ekranına üç senaryoyu özetleyen operasyon kartları eklendi.",
      "Askıda çalışma, timeout, telafi bekleyen etiket, kalıcı DHL hatası, yanlış delivered kaydı ve son 24 saat failed run tek olumsuz kayıt tablosunda izleniyor.",
      "Kritik durum yoksa yeşil veya sarı, varsa kırmızı uyarı ve detay gösteriliyor."
    ]
  },
  {
    "version": 364,
    "date": "2026-06-14",
    "title": "Yanlış Alıcılı Etiket PDF Fallback’i Canlıda Düzeltildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Stok kaynak PDF’inin final müşteri etiketi gibi indirilmesine yol açan fallback kaldırıldı.",
      "Etkilenen etiket doğru alıcı ve adresle yeniden üretildi; aynı hatalı dosya bağının canlıda kalmadığı doğrulandı."
    ]
  },
  {
    "version": 363,
    "date": "2026-06-14",
    "title": "Geçici DHL Kontrol Hatalarına Cron Önceliği Verildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Geçici DHL timeout, browser crash ve HTTP kontrol hataları cron seçiminde normal unchecked kayıtlardan önce yeniden deneniyor.",
      "Askıda carrier run, pending run ve telafi bekleyen hatalı atama bırakılmadığı doğrulandı.",
      "Geçici teknik kontrol hatalarının gerçek hatalı etiket senaryolarına karışması engellendi."
    ]
  },
  {
    "version": 362,
    "date": "2026-06-14",
    "title": "Etsy ve Amazon Yetkilendirme URL Yakalama Döngüsü Hızlandırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Marketplace auth polling ilk anda başlayıp iki saniyede bir çalışacak şekilde sıklaştırıldı.",
      "Bridge açık sekmeleri yarım saniyelik aralıklarla tarıyor ve Etsy URL eşleşmesi düzeltilerek yetkilendirme adresi oluşur oluşmaz yayınlanıyor."
    ]
  },
  {
    "version": 361,
    "date": "2026-06-14",
    "title": "Telafi Bekleyen Etiketler Atomik Yedek Atamayla Temizlendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Telafi etiketi ataması atomik hale getirilerek eşzamanlı kontrollerin aynı yedek etiketi seçmesi engellendi.",
      "Askıda kalan 31 compensation_pending kayıt güvenli biçimde tamamlandı ve telafi bekleyen kuyruk sıfırlandı.",
      "Eski pending telafiler sonraki assigned kontrolünde otomatik yeniden denenecek şekilde kapsama alındı."
    ]
  },
  {
    "version": 360,
    "date": "2026-06-14",
    "title": "Marketplace Auth İşleri Bridge Tarafında Asenkron Başlatılır Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Amazon ve Etsy bağlantı başlangıcı tarayıcı otomasyonunun tamamlanmasını beklemeden job kaydı döndürüyor.",
      "Yetkilendirme URL’si bridge tarafından görüldüğü anda health durumu üzerinden KenPost’a yayınlanıyor; sayaç URL hazır olduğunda başlıyor.",
      "Frontend polling ile gelen URL’yi ve bridge job zamanını koruyarak geç dönen başlangıç yanıtlarında link kaybını önlüyor."
    ]
  },
  {
    "version": 359,
    "date": "2026-06-14",
    "title": "Askıda Kalan DHL Kontrol Çalışmaları Otomatik Kurtarılır Hale Getirildi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Processing veya pending durumda takılı kalan carrier-check çalışmaları self-heal ile failure/completed durumunda kapatılıyor.",
      "Batch, timeout ve concurrency sınırları DHL yavaşlamasında çalışma finalinin yazılabilmesi için düşürüldü.",
      "Eski askıda çalışmalar canlı veride kapatıldı; Etiket Kontrolleri ekranında son başarılı, askıda ve timeout kayıtları ayrı gösteriliyor."
    ]
  },
  {
    "version": 358,
    "date": "2026-06-14",
    "title": "Marketplace Bağlantı Başlatma ve Eski Bekleyen İş Temizliği Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Marketplace bağlantı ekranı status ve health bilgisini iki saniyede bir okuyarak sonradan oluşan URL’yi hazırlık sekmesine yönlendiriyor.",
      "POST zaman aşsa bile URL yakalandıysa popup kapatılmıyor.",
      "Yeni bağlantı ekranı eski mağaza veya job bilgisini taşımıyor; Baştan başlat akışı temiz state ile yeniden başlıyor."
    ]
  },
  {
    "version": 357,
    "date": "2026-06-13",
    "title": "Geç Gelen Marketplace Yetkilendirme Linki Açık Popup’a Güvenle Aktarıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Etsy veya Amazon yetkilendirme URL’si hemen ya da sonradan geldiğinde aynı hazırlık penceresine aktarılıyor.",
      "Popup referansının kaybolup boş beklemesi engellendi.",
      "Bağlantı başlatma zaman aşımı uzatıldı ve bridge’in farklı URL alanları normalize edildi."
    ]
  },
  {
    "version": 356,
    "date": "2026-06-13",
    "title": "Tarayıcı Native Confirm Pencereleri Uygulama İçi Modallarla Değiştirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Mağaza silme, sipariş arşivleme, gönderi iptali, toplu iptal, etiket yenileme, yeniden export ve bağlantıyı kapatma işlemleri uygulama içi onay modallarına taşındı.",
      "Native confirm, alert ve prompt kullanımı gerçek kullanıcı akışlarından kaldırıldı.",
      "Tüm kritik onaylar ortak görsel ve davranış modeline hizalandı."
    ]
  },
  {
    "version": 355,
    "date": "2026-06-13",
    "title": "Etsy Yetkilendirmesi Doğru Salestio Etsy Sayfasına Yönlendirildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Bridge, Etsy bağlantısı için Amazon sayfası yerine doğru Salestio Etsy hesap akışını açıyor.",
      "Amazon bağlantı yolu ayrı tutuldu.",
      "Etsy hesap adı, kaydetme, bağlantı modalı ve yetkilendirme URL’si yakalama adımları eklendi; global tek-iş kilidi korundu."
    ]
  },
  {
    "version": 354,
    "date": "2026-06-13",
    "title": "Marketplace Yetkilendirmesine Geri Sayım ve Yeniden Başlatma Akışı Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Amazon ve Etsy yetkilendirme ekranına iki dakikalık geri sayım ve ilerleme çubuğu eklendi.",
      "Süresi dolan yetkilendirme bağlantıları tamamlanmış sayılmıyor ve kullanıcıya temiz bir yeniden başlatma akışı sunuluyor.",
      "Bağlantı aktif olduğunda başarı mesajı gösterilip kullanıcı otomatik olarak mağazalar listesine yönlendiriliyor.",
      "Aynı bağlantıya ait bekleyen işin yanlışlıkla sistem meşgul uyarısı üretmesi engellendi."
    ]
  },
  {
    "version": 353,
    "date": "2026-06-13",
    "title": "Etsy İçin Canlı D1 Platform Constraintleri ve Mağaza Menüsü Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Canlı D1 platform constraint’leri Etsy değerini kabul edecek şekilde stores, store_credentials, orders ve invoices tablolarında genişletildi.",
      "Tablo satırları ve performans indeksleri korunarak migration kaydı oluşturuldu.",
      "Mağazalar ekranındaki İşlemler menüsünün bağlı mağazalar paneli tarafından kırpılması giderildi."
    ]
  },
  {
    "version": 352,
    "date": "2026-06-13",
    "title": "Amazon ve Etsy Yetkilendirme Akışı Popup ve Tamamlama Modalıyla Yenilendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Amazon ve Etsy bağlantı akışı eski Gadget davranışına yaklaştırıldı.",
      "Yetkilendirme başlatılınca popup artık kullanıcı tıklaması anında açılıyor; API cevabı gelince aynı pencere Amazon/Etsy onay linkine yönleniyor.",
      "Onay sonrası uygulama içinde “Bağlantıyı tamamla” modalı açılıyor."
    ]
  },
  {
    "version": 351,
    "date": "2026-06-13",
    "title": "Dinamik LIKE Sorgusunun Dashboard ve Siparişleri Çökertmesi Giderildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "İptal ve void takip ön eki kontrolündeki dinamik LIKE veya GLOB sorgusu sabit substr ve length mantığına geçirildi.",
      "D1 pattern too complex hatası nedeniyle çöken dashboard, sipariş ve manuel etiket ekranları yeniden çalışır hale geldi.",
      "Etiket ürünleri kaybolmamıştı; ortak API hatası giderilerek ilgili uçların sağlıklı yanıt vermesi sağlandı."
    ]
  },
  {
    "version": 350,
    "date": "2026-06-13",
    "title": "Amazon ve Etsy Bridge Production Domainine Taşındı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Amazon ve Etsy hesap bağlantısı bridge trafiği özel production domainine taşındı.",
      "DNS, TLS, bridge adresi, kimlik doğrulaması ve zaman aşımı ayarları Cloudflare production ortamında hizalandı.",
      "Aynı browser kilidini kullanan otomatik senkron ve metadata-repair işleri kapatılarak bağlantı sırasında gereksiz busy riski kaldırıldı."
    ]
  },
  {
    "version": 349,
    "date": "2026-06-13",
    "title": "PDF’i Kaynak Etikette Kalan Amazon Gönderileri Printed Durumuna Onarıldı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Takibi başarıyla yazılmış ancak PDF alanları boş ve durumu pending kalan Amazon gönderileri doğru tüketilmiş etiket PDF’ine bağlandı.",
      "Etkilenen kayıtlar success/printed durumuna getirildi ve aynı desende eksik kalan gönderi sayısı sıfırlandı.",
      "Kalıcı fallback, shipment PDF alanı boşsa tüketilmiş etiket kaynağındaki dosyayı güvenle kullanacak şekilde eklendi."
    ]
  },
  {
    "version": 348,
    "date": "2026-06-13",
    "title": "Mail Gönderici Domain Hatasına Doğrulanmış Fallback Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Canlı ortamın gönderici adresi doğrulanmış KenPost alan adına taşındı.",
      "Mail sağlayıcısı domain doğrulama hatası döndürürse doğrulanmış fallback göndericiyle bir kez yeniden deneme yapılıyor; doğrulama, şifre sıfırlama ve e-posta 2FA akışları korunuyor."
    ]
  },
  {
    "version": 347,
    "date": "2026-06-13",
    "title": "İptal ve İade Kenar Durumları Kargo Sağlığı ve Sipariş Durumlarından Temizlendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "İptal edilmiş gönderiler artık `shipping-health` raporlarında aktif/giden gönderi gibi sayılmıyor.",
      "İade etiketi iptal edilirse kredi geri dönüyor ama sipariş yanlışlıkla tekrar `open` yapılmıyor.",
      "Manuel iade etiketi oluşturulursa sipariş artık otomatik `shipped` yapılmıyor; sadece outbound etiket bunu yapıyor."
    ]
  },
  {
    "version": 346,
    "date": "2026-06-13",
    "title": "Etsy Resmî Logosuyla Platform Kayıtlarına Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etsy’nin resmî turuncu wordmark logosu platform kayıtlarına eklendi ve ilgili mağaza/bağlantı ekranlarında fallback ikonun yerini aldı.",
      "Bridge busy yanıtı yalnız gerçekten aktif ve süresi dolmamış bir iş varsa bağlantı akışını kilitliyor.",
      "Tamamlanmış, başarısız, süresi dolmuş veya stale işler yeni Etsy bağlantısının başlatılmasını engellemiyor."
    ]
  },
  {
    "version": 345,
    "date": "2026-06-13",
    "title": "İptal Edilen Gönderiler ile Void Stok Etiketleri Ayrı Durumlara Ayrıldı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Müşteri/admin iptalleri artık `shipments.status = cancelled`.",
      "Sistemsel/hatalı stok etiketleri `label_sources.status = void` olarak ayrı kaldı.",
      "`Müşteri İptalleri` ekranı artık teknik `void/failed` kayıtları göstermiyor."
    ]
  },
  {
    "version": 344,
    "date": "2026-06-13",
    "title": "Etsy Entegrasyonu Uçtan Uca Uygulandı",
    "confidence": "implemented",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Ortak marketplace bridge altyapısına Etsy bağlantı, durum, tamamlama, ayırma ve senkron endpointleri eklendi.",
      "Müşteri mağaza bağlantısı, Etsy sipariş cache’i ve kaynak platforma takip geri yazma akışı sisteme işlendi."
    ]
  },
  {
    "version": 343,
    "date": "2026-06-13",
    "title": "Eski Teknik DHL Hatalarının Hatalı Etiket Sayısını Şişirmesi Düzeltildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Eski DHL sorgularından kalan teknik error kayıtları gerçek hatalı etiket sayımından ayrıldı.",
      "Stokta veya müşteriye atanmış 1.797 teknik kontrol hatası nötr ve yeniden kontrol edilebilir duruma getirildi.",
      "Available ve atanabilir stok sayıları tekrar hizalandı; hatalı sayaç yalnız gerçek hareket, void veya remediation gerektiren kayıtları kapsıyor.",
      "Arayüzdeki Check Error kartı daha doğru bir anlamla Hatalı Etiket olarak adlandırıldı."
    ]
  },
  {
    "version": 342,
    "date": "2026-06-13",
    "title": "Etiket Kontrolleri Üç Senaryolu Operasyon Ekranına Dönüştürüldü",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiket Kontrolleri gönderilmiş, atanmış-kullanılmamış ve havuz etiketleri için üç senaryoya ayrıldı.",
      "Her senaryoda son çalışma, bekleyen adet, durum, kontrol ve telafi sayıları ile hata mesajları gösteriliyor.",
      "Admin senaryoyu manuel çalıştırabiliyor ve geçmiş çalışma loglarını inceleyebiliyor."
    ]
  },
  {
    "version": 341,
    "date": "2026-06-13",
    "title": "DHL Durum ve Event Görünümü Admin ve Müşteri Ekranlarına Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Gönderi, etiket envanteri ve hatalı etiket ekranlarında DHL durumu ile event zaman çizelgesi gösteriliyor.",
      "Teslim edilmiş normal gönderilerin hatalı stok listesine karışması ve iade durumlarının teslimatla karıştırılması önlendi."
    ]
  },
  {
    "version": 340,
    "date": "2026-06-13",
    "title": "DHL Teslimat Takibi İçin Üç Senaryolu Otomasyon Kuruldu",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Kullanılmış, müşteriye atanmış kullanılmamış ve havuzdaki etiketler ayrı kurallarla kontrol ediliyor.",
      "Hareketli kullanılmamış etiketler güvenli biçimde void edilip uygun durumda telafi etiketiyle değiştiriliyor."
    ]
  },
  {
    "version": 339,
    "date": "2026-06-13",
    "title": "Müşteri Girişi İçin Erişim Kurtarma Tamamlandı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hesap erişimi güvenli biçimde yenilendi ve giriş akışının çalıştığı doğrulandı."
    ]
  },
  {
    "version": 338,
    "date": "2026-06-13",
    "title": "Hatalı Etiketler Ekranı Tek Ekrana Sığan Sade Listeye Dönüştürüldü",
    "confidence": "verified",
    "audience": [
      "admin"
    ],
    "items": [
      "Hatalı Etiketler tablosu yatay kaydırma gerektirmeyen sade listeye dönüştürüldü.",
      "Not ve kontrol bilgileri sağdan açılan detay paneline taşındı.",
      "PDF ve CSV aksiyonları korunurken gereksiz Envanterde aç butonu kaldırıldı."
    ]
  },
  {
    "version": 337,
    "date": "2026-06-13",
    "title": "Etiket Envanteri Varsayılan Olarak Available Açıldı ve Hatalı Etiketler Ayrıldı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "`Etiket Envanteri` artık ilk açılışta `available` etiketleri gösteriyor; void kayıtlar en başa düşmeyecek.",
      "Menüye ayrı `Hatalı Etiketler` eklendi. Bu ekran sadece `label_sources.status = 'void'` olan stok kaynak etiketlerini gösteriyor.",
      "`İptal Edilen Etiketler` karışmasın diye `Müşteri İptalleri` olarak ayrıldı. Bu ekran sadece müşterinin/adminin iptal ettiği gönderileri gösteriyor."
    ]
  },
  {
    "version": 336,
    "date": "2026-06-12",
    "title": "Otomatik Senkron Zamanlayıcısının Kapasite ve Timeout Sınırları Artırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Otomatik senkron zamanlayıcısının tek çalışmada işleyebildiği mağaza sayısı artırıldı ve platformlar küçük paralel gruplarla çalıştırıldı.",
      "İş zaman aşımı 20 dakikaya çıkarıldı, mağaza çağrılarının süre bütçesi genişletildi ve eşzamanlı workflow çakışmaları engellendi.",
      "Stale eBay running kayıtları temizlendi; canlı sırada işlenmeyi bekleyen mağaza bırakılmadı."
    ]
  },
  {
    "version": 335,
    "date": "2026-06-12",
    "title": "Etiket Bakiye Kartlarındaki Kalan ve Toplam Metrikleri Ayrıştırıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Etiket bakiye kartlarında kalan, toplam, kullanılan ve void adetleri ayrı metrikler olarak gösterilmeye başlandı.",
      "Kalan adet artık Hazır Etiket veya Etiket Kapasitesi gibi yanıltıcı başlıklarla sunulmuyor.",
      "Aynı metrik ayrımı müşteri dashboard’u, sol menü bakiye kartı, Etiket Bakiyeleri ekranı ve admin müşteri görünümlerine uygulandı."
    ]
  },
  {
    "version": 334,
    "date": "2026-06-12",
    "title": "Otomatik Mağaza Senkronu Paralelleştirildi ve eBay Kuyruğa Dahil Edildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Otomatik scheduler mağazaları paralel ve küçük batch’ler halinde çalıştırıyor; eBay de periyodik senkron kapsamına alındı.",
      "eBay yoğunluğunun Amazon ve Shopify’ı bekletmemesi için diğer platformlara öncelik veriliyor; takılı running kayıtları timeout ile kapanıp yeniden deneniyor.",
      "Canlı kuyrukta Amazon, Shopify ve eBay mağazaları başarıyla işlendi ve sırası gelen mağaza kalmadı."
    ]
  },
  {
    "version": 333,
    "date": "2026-06-12",
    "title": "Müşteri Siparişlerine Arşivleme ve Arşivden Çıkarma Akışı Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Arşivlenen siparişler ana listeden varsayılan olarak gizleniyor.",
      "Satır aksiyonlarına Arşivle, ayrı arşiv görünümüne Geri al işlemleri eklendi.",
      "Arşiv durumu siparişin gerçek status, etiket, gönderi ve senkron verilerini değiştirmeyen ayrı alanlarda tutuluyor."
    ]
  },
  {
    "version": 332,
    "date": "2026-06-11",
    "title": "Toplu ZIP İçine Birleşik 00-all-labels PDF’i Yeniden Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Toplu etiket ZIP arşivlerine birleşik 00-all-labels.pdf dosyası otomatik olarak eklenmeye başlandı.",
      "Birleşik dosyanın yanında her etiketin ayrı PDF’i de arşivde korunuyor.",
      "Frontend parametresi eksik olsa bile backend toplu arşivlerde birleşik PDF’i varsayılan olarak üretiyor."
    ]
  },
  {
    "version": 331,
    "date": "2026-06-11",
    "title": "Admin Etiket Yükleme Ekranı Bin Dosyalık Kuyruk ve Retry Desteğiyle Yenilendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Admin etiket yükleme ekranına sürükle-bırak, 1.000 dosyalık kuyruk ve paralel yükleme seçimi eklendi.",
      "Durdurma, hatalıları yeniden deneme, kuyruğu temizleme ve dosya bazlı durum tablosu eklendi.",
      "Yükleme öncesi takip numarasıyla mükerrer kayıt kontrolü yapılıyor ve atlama nedeni gösteriliyor."
    ]
  },
  {
    "version": 330,
    "date": "2026-06-11",
    "title": "Admin Gönderilerinde DHL Linki ve Ürün Ağırlığına Göre Sıralama Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin gönderiler ekranındaki takip numarası artık DHL takip sayfasına link olarak açılıyor.",
      "Gönderiler ekranına `Sıralama: etiket ürünü` seçeneği eklendi. Bu sıralama ağırlığa göre çalışıyor: Kleinpaket, 2 kg, 5 kg gibi doğal sırayla gelir.",
      "Aynı sıralama müşteri gönderileri API’sinde de çalışıyor; CSV export da aynı sıralamayı kullanıyor."
    ]
  },
  {
    "version": 329,
    "date": "2026-06-11",
    "title": "eBay Sipariş Ürün Özeti İçin Tekil Detay ve Eski Format Fallbackleri Eklendi",
    "confidence": "implemented",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Toplu eBay yanıtında ürün bulunmazsa tekil sipariş detayı alınarak ürün özeti oluşturuluyor.",
      "Ham eBay siparişi S3’e bağlandı; parser lineItems, orderItems ve legacy transaction biçimlerini destekleyecek şekilde genişletildi.",
      "Toplamdan birim fiyat hesaplamasını bozan sayı ayrıştırma hatası giderildi."
    ]
  },
  {
    "version": 328,
    "date": "2026-06-11",
    "title": "JTL Adres 2 Alanındaki Tek Başına Kapı Numaraları Temizlendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "JTL Adres 1 zaten kapı numarası içeriyorsa yalnız sayısal Adres 2 satırı etikete taşınmıyor.",
      "Packstation ve Postfiliale gibi gerçekten sayısal ikinci satır gereken adresler korunuyor.",
      "Canlıdaki 73 hatalı JTL adres kaydı temizlenirken metin içeren gerçek ikinci satırlar bırakıldı."
    ]
  },
  {
    "version": 327,
    "date": "2026-06-10",
    "title": "eBay Sipariş Ürün Özetleri D1 Cache’ine Yazılmaya Başlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "eBay senkronu ürün başlığı, adet, SKU, toplam, ödeme ve fulfillment özetini D1 sipariş özeti önbelleğine yazıyor.",
      "Sipariş listesinde eBay ürünlerinin boş görünmesi giderildi.",
      "Eski kayıtlar mağaza yeniden senkronlandığında özet bilgilerle dolduruluyor."
    ]
  },
  {
    "version": 326,
    "date": "2026-06-10",
    "title": "Amazon Bridge Mağazaları Otomatik Senkron Kuyruğuna Dahil Edildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Aktif Amazon bridge bağlantıları ayrı credential satırı bulunmasa da otomatik senkron kuyruğuna dahil edildi.",
      "Amazon için varsayılan otomatik tarama aralığı 7 günden 30 güne çıkarıldı.",
      "Zamanlanmış kontrol on dakikada bir sırası gelen mağazaları platform bazında işler hale getirildi.",
      "Senkron loglarında tarama aralığı, kaynak ve otomatik çalışma türü görünür hale geldi."
    ]
  },
  {
    "version": 325,
    "date": "2026-06-09",
    "title": "Tekli Manuel Etiket Formu Gereksiz Firma, Önizleme ve İletişim Alanlarından Arındırıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Tekli manuel etiketten Firma veya c/o, önizleme, telefon ve e-posta alanları kaldırıldı.",
      "Adres placeholder’ı iletişim örneklerinden temizlenip form sadeleştirildi.",
      "Telefon ve e-posta artık manuel sipariş payload’ına gönderilmiyor."
    ]
  },
  {
    "version": 324,
    "date": "2026-06-09",
    "title": "Admin Müşteri Hesabı Kurtarma İşlemleri Eklendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Admin müşteri detayına e-postayı doğrulama, doğrulama veya şifre sıfırlama maili gönderme, hesabı aktif/pasif yapma ve e-posta 2FA’yı kapatma işlemleri eklendi.",
      "Etkilenen müşteri hesabı canlı veride doğrulanıp aktif hale getirildi; ilgili admin endpoint’leri devreye alındı."
    ]
  },
  {
    "version": 323,
    "date": "2026-06-09",
    "title": "Public Destek, Gizlilik, SSS, Dokümantasyon, Fiyat ve Changelog Sayfaları Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Destek, Gizlilik, SSS, Dokümantasyon, Fiyatlandırma ve Changelog için public sayfalar eklendi.",
      "Giriş ve kayıt ekranlarının altına resmî bilgi sayfalarının bağlantıları yerleştirildi.",
      "Robots ve sitemap kayıtları yeni public sayfaları ve uygulama domainini kapsayacak şekilde güncellendi."
    ]
  },
  {
    "version": 322,
    "date": "2026-06-09",
    "title": "Başka Bir Müşteri Hesabında Erişim Kurtarma Tamamlandı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hesap giriş bilgileri güvenli biçimde yenilendi ve canlı oturum açma testi doğrulandı."
    ]
  },
  {
    "version": 321,
    "date": "2026-06-09",
    "title": "Eksik Otomatik Sipariş Senkron Endpoint’leri ve Admin Kontrolleri Eklendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Sırası gelen mağazaları çalıştıran endpoint ile senkron çalışma raporu endpoint’i eklendi; admin platform ekranına toplu ve satır bazlı senkron aksiyonları getirildi.",
      "Müşteri mağazasındaki otomatik senkron ve kontrol sıklığı ayarları kalıcı hale getirildi; başarısız bağlantılar için tekrar deneme aralığı uygulandı.",
      "Canlı kuyruk çalıştırılarak sırası gelen Shopify mağazaları işlendi ve bekleyen due kuyruğu temizlendi."
    ]
  },
  {
    "version": 320,
    "date": "2026-06-09",
    "title": "Canlı Test Fatura ve Satın Alma Kayıtları Temizlendi",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Shopify tarafındaki test draft order ile KenPost test satın alma kaydı silindi.",
      "İlgili test faturasının listeden kalktığı ve canlı veride artık satır kalmadığı doğrulandı."
    ]
  },
  {
    "version": 319,
    "date": "2026-06-09",
    "title": "JTL Takip Kuyruklarındaki Zincirli Hatalar Retry ile Temizlendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Zincirli JTL ‘tracking başka pakette’ hataları için kontrollü çok geçişli retry eklendi.",
      "Replacement olarak işaretlenen eski paket satırları ve KENPOST-REPLACED tombstone takipleri güvenle eşleştiriliyor.",
      "Etkilenen JTL gönderileri yeniden yazılıp Amazon kuyruğuna başarıyla alındı; aktif başarısız kayıt bırakılmadı."
    ]
  },
  {
    "version": 318,
    "date": "2026-06-09",
    "title": "Fatura PDF Alt Bilgileri ve QR Alanı Geri Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Fatura PDF’lerine satıcı ve alt bilgi varsayılanları geri getirildi.",
      "USt-IdNr, vergi numarası, sahip, banka ve IBAN veya BIC bilgileri yeniden gösteriliyor.",
      "MAK ve etiket satın alma PDF’lerine Online Original QR alanı Worker içinde doğrudan çizilerek eklendi."
    ]
  },
  {
    "version": 317,
    "date": "2026-06-09",
    "title": "Billbee Sipariş İçe Aktarımı Batch Yazım ve Güvenli Tekilleştirmeye Geçti",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Billbee import tek tek D1 yazımı yerine batch işlemeye geçirildi.",
      "Eski ve yeni kayıtlar sipariş numarası üzerinden eşleştirilip dış sipariş kimliği normalize edildi; mükerrer kayıt oluşumu engellendi.",
      "Otuz günlük canlı senkron yeniden tamamlandı ve timeout kaynaklı boş mükerrer satırlar temizlendi.",
      "Amazon biçimli numaralarda arama varyantlarının D1 parametre limitini aşması düzeltildi."
    ]
  },
  {
    "version": 316,
    "date": "2026-06-09",
    "title": "Shopify Ödeme Uygulaması Stratejisi Dokümante Edildi",
    "confidence": "implemented",
    "audience": [
      "system"
    ],
    "items": [
      "KenPost etiket/kredi satışlarının Shopify üzerinden tahsil edilmesine odaklanan mimari ve sınırlar yazılı hale getirildi.",
      "Müşteri mağazasından sipariş çekme kapsamı ödeme uygulamasından ayrıştırıldı."
    ]
  },
  {
    "version": 315,
    "date": "2026-06-09",
    "title": "JTL Bridge Fatura ve Teslimat Adresi Tipleri Doğru Yorumlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "JTL bridge’de ters yorumlanan adres tipi eşlemesi düzeltildi: nTyp=0 teslimat, nTyp=1 fatura adresi olarak işleniyor.",
      "Aynı JTL mağazasındaki 876 siparişin adres snapshot’ı doğru teslimat ve fatura kayıtlarına göre onarıldı.",
      "Eski bridge ters payload gönderse bile Pages tarafındaki uyumluluk koruması yeni senkronların tekrar bozulmasını engelliyor.",
      "Daha önce üretilmiş PDF’ler otomatik değiştirilmedi; doğru fiziksel etiket için yeniden üretim gerekiyor."
    ]
  },
  {
    "version": 314,
    "date": "2026-06-09",
    "title": "eBay Üç Aylık Sipariş Geçmişi Tamamlandı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Eksik eBay siparişleri üç aylık senkronla yeniden alınarak geçmiş kayıtlar tamamlandı.",
      "eBay için 3 gün, 7 gün, 30 gün, 3 ay ve tümü senkron aralıkları doğru çalışacak şekilde düzeltildi."
    ]
  },
  {
    "version": 313,
    "date": "2026-06-09",
    "title": "Cloudflare CSS Cache ve HTML Fallback Hatası Giderildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "CSS dosyasının HTML içerik türüyle dönmesine yol açan cache kaydı temizlendi.",
      "Yeni stylesheet çıktısı production’a alınarak canlı arayüzün stylesiz açılması durduruldu."
    ]
  },
  {
    "version": 312,
    "date": "2026-06-09",
    "title": "Fatura Tutarlarının Yanlış Sıfırlanması Giderildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Boş fiyat override değerlerinin sıfır kabul edilmesi nedeniyle oluşan 0,00 € hatası düzeltildi.",
      "Bonus ve telafi kayıtlarının ücretsiz fatura davranışı korunurken normal satın almalar gerçek tutarla gösteriliyor."
    ]
  },
  {
    "version": 311,
    "date": "2026-06-09",
    "title": "Fatura PDF Şablonu A4 Rechnung Düzenine Yaklaştırıldı",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Satıcı ve alıcı blokları, satır tablosu, net/KDV/brüt toplamları ve alt bilgi eski referans düzenine göre yenilendi.",
      "Shopify ve manuel Shopify faturaları aynı görsel yapıyı kullanıyor."
    ]
  },
  {
    "version": 310,
    "date": "2026-06-09",
    "title": "Shopify Manuel Fatura Tamamlama İşlemine Retry ve Temizlik Koruması Eklendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Shopify draft order hesaplaması geciktiğinde manuel fatura tamamlama işlemi kontrollü olarak yeniden deneniyor.",
      "Tamamlama başarısız kalırsa açık draft temizleniyor; başarılı işlem tek satın alma kaydı oluşturuyor ve etiket bakiyesine dokunmuyor."
    ]
  },
  {
    "version": 309,
    "date": "2026-06-09",
    "title": "Manuel Faturalar Shopify Üzerinden Paid Order Olarak Oluşturulmaya Başlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Admin tarafından oluşturulan manuel faturalar Shopify’da paid order referansı olarak kaydediliyor ve kredi bakiyesini değiştirmiyor.",
      "Fatura ekranına PayPal, kredi kartı, manuel ve banka transferi ödeme yöntemleri eklendi.",
      "Manuel fatura formundaki müşteri seçimi aramalı ve alfabetik hale getirildi."
    ]
  },
  {
    "version": 308,
    "date": "2026-06-09",
    "title": "Shopify Sipariş Adı Eksik Faturalarda MAK Numaraları Onarıldı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Eksik Shopify sipariş adı metadata’sı canlı satın alma kayıtlarına eklendi ve MAK numaraları doğru sipariş numarasından üretildi.",
      "Sipariş adı yoksa uzun Shopify order ID’sinden sahte MAK numarası üretilmesi ve PDF’in yanlış numarayla devam etmesi engellendi.",
      "Fatura ekranındaki yanıltıcı Draft ifadesi kaldırıldı; kredi sepeti özeti, Not alanı ve Kredi ekle butonu düzenlendi."
    ]
  },
  {
    "version": 307,
    "date": "2026-06-09",
    "title": "Manuel Faturalar Korunurken Otomatik Label-Cart Faturaları Gizlendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Shopify etiket satın alma faturaları ile admin tarafından bilinçli oluşturulan manuel faturalar görünür tutuldu.",
      "Otomatik kredi veya etiket atamalarından oluşan eski LABEL-CART faturaları fatura listelerinden gizlendi.",
      "Yeni kredi atamalarında otomatik fatura oluşturulmayacak; gerektiğinde mevcut manuel fatura akışı kullanılacak."
    ]
  },
  {
    "version": 306,
    "date": "2026-06-09",
    "title": "Shopify Satın Alma Faturaları Çok Ürünlü ve Tekilleştirilmiş Görünüme Geçti",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer",
      "system"
    ],
    "items": [
      "Admin ve müşteri fatura ekranları Shopify kaynaklı etiket satın alma faturalarını gösterecek şekilde düzenlendi.",
      "Aynı Shopify siparişindeki çoklu ürünler tek fatura altında satırlandırıldı; eski mükerrer satın alma kayıtları ekranda ve PDF’te tekilleştirildi.",
      "PDF çıktısı siparişteki tüm ürün satırlarını içeriyor ve fatura numarası Shopify sipariş sırasına göre yeniden oluşturuluyor.",
      "Fatura liste kapasitesi 100 kayıttan 150 kayda çıkarıldı."
    ]
  },
  {
    "version": 305,
    "date": "2026-06-09",
    "title": "Admin Kredi Ekleme Ekranı Tüm Ürünleri Gösteren Sepet Tablosuna Geçirildi",
    "confidence": "verified",
    "audience": [
      "admin"
    ],
    "items": [
      "“Krediler ve Etiketler” ekranındaki dropdown + satır ekleme yapısı kaldırıldı.",
      "Tüm aktif etiket ürünleri tek tabloda görünüyor.",
      "Ürünler kg/ağırlık sırasına göre listeleniyor."
    ]
  },
  {
    "version": 304,
    "date": "2026-06-09",
    "title": "JTL Takip Retry ve Eski Paket Değiştirme Mantığı Uygulandı",
    "confidence": "implemented",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Toplu etiket akışı, etiketi zaten bulunan JTL siparişlerinde takip senkronu pending veya failed ise yeniden deniyor.",
      "Eski başka siparişte kalan paket takibi açık replacement sinyaliyle emekliye ayrılıp yeni siparişe yazılabiliyor; etkilenen canlı kayıtlar başarı durumuna getirildi."
    ]
  },
  {
    "version": 303,
    "date": "2026-06-08",
    "title": "Manuel Sipariş Durumları ve Toplu Ürün Önerisi Onarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiketi bulunan manuel siparişler shipped durumuna geçirildi; geçmişte açık kalan binlerce kayıt düzeltildi.",
      "Toplu önizlemede ağırlığa göre ürün önerisi yapılıyor ve popup açılırken etiket üretimi başlamıyor."
    ]
  },
  {
    "version": 302,
    "date": "2026-06-08",
    "title": "Manuel Adres Önerisi Zorunluluğu Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Kullanıcılar öneri listesindeki bir şehri seçmeden kendi yazdıkları adresle devam edebiliyor.",
      "Klavye ile öneri kapatma ve çok dilli “yazdığım adresle devam et” seçeneği eklendi."
    ]
  },
  {
    "version": 301,
    "date": "2026-06-08",
    "title": "Toplu ZIP İçindeki Mükerrer PDF Dosyaları Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Varsayılan toplu ZIP yalnızca normal etiket PDF’lerini içeriyor.",
      "Birleşik PDF ve Adobe varyantlarından kaynaklanan çift kopyalar kaldırıldı."
    ]
  },
  {
    "version": 300,
    "date": "2026-06-08",
    "title": "JTL Ağırlık Önerisi Stückliste ve Farklı Alan Biçimleriyle Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Kilogram, gram, snake_case alanlar ve ağırlıksız üst ürünlerde parça ağırlıkları ortak hesaplamaya dahil edildi.",
      "Ağırlık bilinmiyorsa yanlış Kleinpaket seçmek yerine ürün seçimi kullanıcıya bırakılıyor."
    ]
  },
  {
    "version": 299,
    "date": "2026-06-08",
    "title": "Toplu Etiket Üretimi Öncesi Satır Bazlı Kontrol Popup’ı Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Toplu etiket üretimi, seçili siparişlerde doğrudan işlem yapmak yerine önce kontrol popup’ı açacak şekilde düzenlendi.",
      "Her sipariş için etiket ürünü, ağırlık, kredi özeti ve adres alanları ayrı ayrı incelenip düzenlenebiliyor.",
      "Eksik ürün veya adres bulunan satırlarda onay düğmesi pasif kalıyor; açık kullanıcı onayı verilmeden gönderi oluşturulmuyor."
    ]
  },
  {
    "version": 298,
    "date": "2026-06-08",
    "title": "Kaufland Sipariş Görünürlüğü ve Almanca Arayüz Çevirileri Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Kaufland siparişlerinin bağlı mağaza listesinde ve sipariş tablosunda görünürlüğü doğrulandı.",
      "Almanca mağaza filtresi, durumlar, senkron aksiyonları ve satır sayısı metinleri tamamlandı.",
      "Store alanının yanlışlıkla Speichern olarak çevrilmesi düzeltildi ve seçenek metinleri çeviri kapsamına alındı."
    ]
  },
  {
    "version": 297,
    "date": "2026-06-08",
    "title": "Müşteri Gönderilerine Kuyruklu Toplu İptal Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Seçili gönderiler tek tek kuyrukta iptal ediliyor; büyük seçimlerde tüm işlem tek hatada durmuyor.",
      "İlerleme çubuğu, başarılı ve hatalı sayıları ile satır bazlı sonuçlar gösteriliyor.",
      "Başarılı kayıtlar seçimden otomatik çıkarılıyor."
    ]
  },
  {
    "version": 296,
    "date": "2026-06-08",
    "title": "Takılı Shopify, Kaufland, Amazon ve Billbee Senkronları Onarıldı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Eski Shopify takip hataları yeniden senkronlanarak aktif başarısız kayıtlar temizlendi.",
      "Kaufland, Amazon ve Billbee için tarih aralığı/timeout kaynaklı takılmalar giderilip siparişler yeniden işlendi."
    ]
  },
  {
    "version": 295,
    "date": "2026-06-08",
    "title": "Kritik Etiket ve Senkron Akışları İçin Nöbet Otomasyonu Kuruldu",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Etiket üretimi, takip yazımı ve mağaza senkronlarını düzenli aralıklarla kontrol eden geçici sağlık nöbeti devreye alındı.",
      "Aktif hata ve takılı işlem sayıları canlı kontrollerle izlenebilir hale getirildi."
    ]
  },
  {
    "version": 294,
    "date": "2026-06-08",
    "title": "Toplu JTL Etiketlerinde Ürün Ağırlığa Göre Otomatik Seçildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Toplu JTL etiket üretiminde her siparişin ağırlığı ayrı değerlendirilerek uygun en küçük DHL ürünü otomatik seçiliyor.",
      "Tek bir varsayılan ürünün farklı ağırlıktaki bütün siparişlere uygulanması engellendi.",
      "Uygun ürün veya kredi bulunamazsa yanlış Kleinpaket üretmek yerine satır bazlı hata gösteriliyor.",
      "Toplu işlemdeki adres değişikliklerinin backend tarafından doğru okunması sağlandı."
    ]
  },
  {
    "version": 293,
    "date": "2026-06-08",
    "title": "Amazon Takip Yazımı Kaynak Shopify Fulfillment Akışına Taşındı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Amazon takip numarası doğrudan bridge’e değil, Amazon’a bağlı kaynak Shopify mağazasındaki fulfillment kaydına yazılıyor.",
      "Cache’te sipariş bulunmazsa kaynak mağazada Amazon sipariş kimliğiyle arama yapılıyor; mevcut fulfillment tracking boşsa güvenli biçimde güncelleniyor.",
      "Eski bridge 403 hataları yeniden denendi ve güvenle eşleştirilebilen kayıtlar success durumuna getirildi."
    ]
  },
  {
    "version": 292,
    "date": "2026-06-08",
    "title": "JTL Takip Yeniden Deneme ve Void Takip Değiştirme Akışı Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL manuel takip senkronu success kaydında dahi bridge’e giderek eBay, webshop ve SCX kuyruklarını yeniliyor.",
      "Void edilmiş eski takiplerin replacement listesi ve paket ağırlığı bridge’e iletiliyor.",
      "Canlı bridge ve ilgili JTL gönderileri yeniden kuyruklanarak başarılı duruma getirildi."
    ]
  },
  {
    "version": 291,
    "date": "2026-06-08",
    "title": "Kaçırılan Shopify Ödemeleri Müşteri Sayfasında Otomatik Uzlaştırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Kaçırılan bir Shopify ödemesi canlıda tek satın alma kaydıyla uzlaştırılıp 20 Kleinpaket kredisi eklendi.",
      "Webhook veya ödeme dönüşü kaçarsa müşteri Etiket satın al ya da Bakiyeler sayfasını açtığında son 14 günün ödenmiş siparişleri otomatik taranıyor.",
      "İdempotent kontrol aynı ödemeden çift kredi yazılmasını engelliyor."
    ]
  },
  {
    "version": 290,
    "date": "2026-06-08",
    "title": "Etiket Yenileme İçin Açık Onay ve Backend Kilidi Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Etiketi yenile aksiyonu önce açık onay penceresi gösteriyor.",
      "Onay, aynı takip numarası ve ürünle yalnız PDF veya ZIP yeniden üretileceğini açıklıyor; ürün veya kredi değişikliği için iptal sonrası yeni etiket gerekiyor.",
      "Backend açık confirmed parametresi olmadan regenerate isteğini reddediyor."
    ]
  },
  {
    "version": 289,
    "date": "2026-06-08",
    "title": "Sadece Gönderilmemiş Filtresi Aktif Etiketi Olan Siparişleri Dışladı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sadece gönderilmemiş filtresi açık durumun yanında aktif gönderisi bulunmama koşulunu da uyguluyor.",
      "Etiketi veya takip numarası bulunan siparişler listeden çıkarılıyor; arayüz ve backend aynı waiting koşulunu zorunlu tutuyor."
    ]
  },
  {
    "version": 288,
    "date": "2026-06-08",
    "title": "Almanca Karakterlerin Etiket Metninde Korunması Sağlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sipariş içe aktarımından sonra etiket/PDF metninde ö, ü, ä ve ß gibi karakterlerin ASCII’ye çevrilmesi engellendi.",
      "Müşteri gönderici profilindeki şehir yazımı ve canlı adres normalizasyonu aynı Unicode davranışıyla düzeltildi."
    ]
  },
  {
    "version": 287,
    "date": "2026-06-08",
    "title": "Shopify Senkron Aralıkları API’ye Uygulanıp Takılı Çalışmalar Temizlendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Shopify için 3 gün, 7 gün, 30 gün ve tüm geçmiş senkron aralıkları gerçek API sorgusuna uygulanmaya başlandı.",
      "Tüm geçmiş seçildiğinde sabit başlangıç tarihi gönderilmediği için gereksiz uzun tarama ve zaman aşımı riski azaltıldı.",
      "Yeni senkron başlarken stale running kayıtları otomatik kapatılıyor; takılı çalışma kayıtları temizlendi."
    ]
  },
  {
    "version": 286,
    "date": "2026-06-08",
    "title": "JTL Bridge Takip Numarası Geri Yazma Endpoint’i Uygulandı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL bridge’e takip numarası geri yazma endpoint’i eklendi.",
      "Etiket oluşturma sonrası mevcut kaynak takip senkronu bu endpoint üzerinden JTL MSSQL writeback akışını çalıştırıyor.",
      "Sipariş ve paket kayıtları güncellenip ilgili eBay veya Amazon kuyruklarına aktarılabiliyor."
    ]
  },
  {
    "version": 285,
    "date": "2026-06-08",
    "title": "JTL Canlı Adres Resolver’ı Gerçek Teslimat Kayıtlarını Kullanacak Şekilde Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "JTL adres çözümleyicisi müşteri eşleşmesine takılmadan siparişin gerçek teslimat ve fatura adresi kayıtlarını kullanıyor.",
      "Generic Laufkunde fallback’ine yanlış düşen siparişler yeniden senkronlandı.",
      "Sipariş araması tam numara eşleşmelerini önceleyecek şekilde daraltılıp alaka sıralaması düzeltildi."
    ]
  },
  {
    "version": 284,
    "date": "2026-06-08",
    "title": "İkinci Bir Müşteri Hesabında Erişim Kurtarma Tamamlandı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hesap erişimi güvenli biçimde yenilendi ve canlı giriş testi başarıyla tamamlandı."
    ]
  },
  {
    "version": 283,
    "date": "2026-06-08",
    "title": "JTL Bridge MSSQL ESM Import Hatası Giderildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "MSSQL bağlantı havuzunun yanlış modül içe aktarımı düzeltilerek bridge yeniden derlenip başlatıldı.",
      "Canlı MSSQL’den sipariş okunması ve birden fazla mağaza bağlantısı doğrulandı."
    ]
  },
  {
    "version": 282,
    "date": "2026-06-08",
    "title": "JTL Bridge Production Ayarları Cloudflare Ortamına Bağlandı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Cloudflare production ortamı JTL bridge adresi, kimlik doğrulaması ve zaman aşımı ayarlarıyla güncellendi.",
      "Cloudflare uygulaması ile bridge arasındaki yetkisiz veya eksik yapılandırma hatası giderildi."
    ]
  },
  {
    "version": 281,
    "date": "2026-06-08",
    "title": "Bir Müşteri Hesabında Erişim Kurtarma Tamamlandı",
    "confidence": "operational",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Hesabın giriş bilgileri güvenli biçimde yenilendi; aktiflik, doğrulama ve iki aşamalı giriş durumu kontrol edildi."
    ]
  },
  {
    "version": 280,
    "date": "2026-06-08",
    "title": "Sipariş Araması Müşteri, Adres, Ürün, Takip ve Mağaza Alanlarına Genişletildi",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Arama sipariş numarası, dış sipariş kimliği, müşteri, iletişim, gönderim ve fatura adresi, mağaza, platform, ürün, SKU, takip ve etiket ürünü alanlarına genişletildi.",
      "Arama yapıldığında Sadece gönderilmemiş, durum ve etiket filtrelerinin eşleşen kaydı istemeden gizlemesi engellendi.",
      "Gönderilmiş ve etiketli kayıtlar da doğrudan aramayla bulunabilir hale geldi."
    ]
  },
  {
    "version": 279,
    "date": "2026-06-08",
    "title": "Siparişler Gerçek Platform Tarihine Göre Sıralanmaya Başlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Siparişler iç kayıt oluşturma zamanı yerine gerçek platform sipariş tarihiyle sıralanıyor.",
      "Tarihi eksik eski veya migrasyon kayıtlarının yeni siparişlerin üstüne çıkması engellendi.",
      "Yeni platform senkronları gerçek sipariş tarihini özet önbelleğine yazıyor."
    ]
  },
  {
    "version": 278,
    "date": "2026-06-08",
    "title": "Platform Sipariş SKU Bilgisi Etiket Üretimine Aktarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sipariş SKU’su ortak platform çıkarıcısıyla etiket üretimine aktarılıyor.",
      "SKU önce hızlı önbellekten, gerekirse S3 sipariş kaydından okunuyor.",
      "Mağaza ayarı kapalıysa yazılmıyor; eski etiketler yeniden üretildiğinde yeni SKU satırını alıyor."
    ]
  },
  {
    "version": 277,
    "date": "2026-06-08",
    "title": "Shopify Token Yenileme ve Süresi Dolmuş Bağlantı Kurtarma Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Shopify bağlantıları kalıcı token ve client credentials modellerini destekliyor.",
      "Senkron sırasında süresi dolan token otomatik yenileniyor; 401 sonrası bir kez zorunlu refresh ve retry yapılıyor.",
      "Aynı yenileme mantığı takip ve fulfillment yazımında da kullanılıyor; yenilenemeyen doğrudan tokenlarda yeniden bağlantı isteniyor.",
      "Canlı client-credentials mağazalarındaki süresi dolmuş tokenlar yenilenip açık hata bırakılmadı."
    ]
  },
  {
    "version": 276,
    "date": "2026-06-08",
    "title": "Siparişten Etiket Oluşturma Öncesi Kontrol Popup’ı Geri Getirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Sipariş satırındaki Etiket aksiyonu doğrudan üretim yerine önce kontrol popup’ı açıyor.",
      "Popup sipariş özeti, ürünler, ağırlık, toplam, ürün seçimi, kredi ve kargo adresi düzenleme alanlarını gösteriyor.",
      "Etiket yalnız popup içindeki açık onayla oluşturuluyor."
    ]
  },
  {
    "version": 275,
    "date": "2026-06-08",
    "title": "Kritik Etiket, Takip ve Senkron Akışları İçin Canlı İzleme Kuruldu",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "Etiket üretimi, manuel etiket, takip yazımı ve mağaza senkronları düzenli sağlık kontrolleriyle izlendi.",
      "Takılmış pending ve aktif başarısız kayıtlar için görünür kontrol noktaları oluşturuldu."
    ]
  },
  {
    "version": 274,
    "date": "2026-06-08",
    "title": "Sadece Gönderilmemiş Filtresinin Etiketli Açık Siparişleri Gizlemesi Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sadece gönderilmemiş filtresi artık yalnız açık ve gönderilmemiş sipariş durumuna göre çalışıyor.",
      "Etiket durumu ayrı filtre olarak korunarak etiketi bulunan açık siparişlerin yanlışlıkla gizlenmesi önlendi.",
      "Yenile metni Listeyi yenile olarak netleştirildi; yeni sipariş çekme aksiyonu senkron butonunda kaldı."
    ]
  },
  {
    "version": 273,
    "date": "2026-06-08",
    "title": "JTL S3 Sipariş Cache’i D1 Sipariş Tablosuna Aktarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Eski JTL S3 cache’indeki 574 sipariş D1 sipariş tablosuna aktarıldı.",
      "Canlı bridge erişilemezse son geçerli JTL cache’ini D1’e yeniden işleyen fallback eklendi.",
      "Tek mağaza senkronu hata aldığında yanlış başarı mesajı gösterilmesi engellendi."
    ]
  },
  {
    "version": 272,
    "date": "2026-06-08",
    "title": "S3 Etiket Şablonu Okumadaki SignatureDoesNotMatch Hatası Giderildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Kaynak etiket PDF’leri presigned URL yerine doğrudan S3 header-imzalı GET ile okunuyor.",
      "İmza uyuşmazlığına yol açan response content override parametreleri kaldırıldı.",
      "Etiket oluştururken oluşan 403 ve failed hatası giderildi; daha önce tüketilen kredilerin güvenli iadesi korundu."
    ]
  },
  {
    "version": 271,
    "date": "2026-06-08",
    "title": "Gadget–Cloudflare Geçişi Öncesi Son Veritabanı Yedekleri Alındı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Gadget production snapshot’ı ve Cloudflare D1 geçiş öncesi SQL yedeği oluşturuldu.",
      "Geri dönüş ve veri karşılaştırması için arşivli kopyalar saklandı."
    ]
  },
  {
    "version": 270,
    "date": "2026-06-07",
    "title": "Cloudflare Shopify Checkout Akışına Gadget Koruma ve Retry Paritesi Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Ülke değerleri Shopify’ın kabul ettiği Germany ve DE biçimine normalize edildi.",
      "Draft order validasyon hatalarında minimal payload ile kontrollü yeniden deneme eklendi.",
      "KDV hesaplama gecikmesi, kısmi işlenmiş sepetler ve eski tekil checkout kayıtları için parite korumaları eklendi.",
      "Shopify billing geçmişi 250 kayıt sınırına takılmadan sayfalı taranıyor."
    ]
  },
  {
    "version": 269,
    "date": "2026-06-07",
    "title": "JTL Kargo ve Fatura Adres Snapshot’ları Cloudflare Importuna Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL import ve connector akışları teslimat ve fatura adresi snapshot’larını ayrı ayrı kaydedecek şekilde genişletildi.",
      "Etiket adresi teslimat adresini önceliklendiriyor; yalnız teslimat adresi yoksa fatura adresi kullanılıyor.",
      "Sipariş detay API’si shippingAddress, billingAddress ve iki adresin farklı olup olmadığı bilgisini döndürüyor."
    ]
  },
  {
    "version": 268,
    "date": "2026-06-07",
    "title": "Gadget Production Verileri Cloudflare D1’e Son Snapshot ile Taşındı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Son Gadget production snapshot’ı Cloudflare D1’e aktarıldı ve kritik tablolar kayıt bazında karşılaştırıldı.",
      "Kullanıcı, fiyat, bakiye, satın alma, gönderi, etiket kaynağı, eBay bağlantısı, arşiv ve hata logu kayıtlarında Gadget kaynaklı eksik bırakılmadı.",
      "Cloudflare tarafında daha önce oluşmuş 6.951 ek sipariş veri kaybını önlemek için korundu.",
      "Eksik order-sync kolonları, çalışma tabloları, performans indeksleri ve özet cache migration’ları tamamlandı; mevcut şifrelerin import sırasında ezilmesi engellendi."
    ]
  },
  {
    "version": 267,
    "date": "2026-06-05",
    "title": "Gadget Etiket Satın Alma Sayfası Çok Ürünlü Sepete Geçirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Gadget etiket satın alma sayfası çok ürünlü sepet modeline geçirildi.",
      "Sepette toplam adet, net, MwSt ve brüt toplamlar gösteriliyor; checkout tüm kalemleri birlikte gönderiyor.",
      "Ödeme sonrası her ürün kendi bakiyesine işleniyor; eski tek ürün kayıtlarıyla uyumluluk korunuyor.",
      "Shopify billing scheduler dar kapsamlı çalışacak şekilde hafifletildi."
    ]
  },
  {
    "version": 266,
    "date": "2026-06-05",
    "title": "Shopify Checkout Popup Engeline Dayanıklı Açılma Akışı Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Checkout penceresi kullanıcı tıklaması anında açılıyor; URL hazır olduğunda Shopify’a yönlendiriliyor.",
      "Popup engellenirse aynı sekmeye güvenli fallback uygulanıyor.",
      "Süresi dolmuş bekleyen checkout tokenları temizlenerek tekrar eden hata kayıtları azaltıldı."
    ]
  },
  {
    "version": 265,
    "date": "2026-06-04",
    "title": "JTL Stückliste Ağırlık Düzeltmesi Gadget ve Cloudflare’da Eşitlendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Ana ürün ve bağlı stok satırı birlikte geldiğinde alt ürün ağırlığının ikinci kez eklenmesi hem Gadget hem Cloudflare akışında engellendi.",
      "JTL connector mevcut siparişin ağırlığını yeniden senkronlayabiliyor; ürün önizlemesi Stückliste alt satırlarını gizliyor ve eski hatalı item cache’i yenileniyor."
    ]
  },
  {
    "version": 264,
    "date": "2026-06-04",
    "title": "JTL Stückliste Ağırlıklarının İki Kez Sayılması Giderildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL Stückliste siparişlerinde ana ürün ile bağlı component/stok satırlarının ağırlığının iki kez toplanması engellendi.",
      "Ana satıra bağlı Stückliste alt satırları ürün ve ağırlık toplamından çıkarılıyor.",
      "Sipariş listesi, ürün önizlemesi, otomatik kilo seçimi ve etiket fallback hesabı aynı filtreleme kuralına bağlandı."
    ]
  },
  {
    "version": 263,
    "date": "2026-06-04",
    "title": "JTL Etiketlerinde Teslimat Adresi Önceliği Genel Kurala Dönüştürüldü",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL etiketleri önce teslimat adresini, yalnız eksikse fatura adresini kullanıyor.",
      "Sipariş listesi, adres kartı, detay sayfası ve backend aynı adres çözümleme kuralına bağlandı.",
      "Teslimat ve fatura adresi farklı olduğunda arayüzde ayrı gösteriliyor."
    ]
  },
  {
    "version": 262,
    "date": "2026-06-04",
    "title": "JTL Siparişinde Fatura ve Teslimat Adresi Ayrımı Canlı Veride Düzeltildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "JTL siparişindeki fatura ve teslimat adresleri ayrıştırıldı; mevcut kayıt doğru teslimat adresine güncellendi.",
      "Duplicate shipment koruması erken dönse bile sipariş adresi son kaynak teslimat adresiyle yenileniyor.",
      "Yeniden oluşturulan etiketler teslimat adresini kullanıyor; eski PDF otomatik değiştirilmedi."
    ]
  },
  {
    "version": 261,
    "date": "2026-06-03",
    "title": "Gadget Geçici 5xx Sonrası Satın Alma Onarım Cursor Hatası Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Satın alma onarım görevindeki cursor sayfalaması doğru sıralama alanlarıyla düzeltildi.",
      "Geçici 502 ve 503 dalgalanmasından sonra giriş, sipariş ve gönderi uçlarının sağlıklı yanıt verdiği doğrulandı.",
      "Düzeltme sonrası yeni zamanlanmış işlem hatası gözlenmedi."
    ]
  },
  {
    "version": 260,
    "date": "2026-06-03",
    "title": "Etiketi Bulunan Eski Gönderiler Müşteri Envanter İlişkisinden Görünür Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Gönderi görünürlüğü yalnız shipment kullanıcı bağlantısıyla sınırlı kalmıyor; müşteriye atanmış tüketilmiş etiket kaynağı da sahiplik kanıtı olarak kullanılıyor.",
      "Eski gönderiler müşteri gönderi listesinde yeniden görünür hale geldi.",
      "Müşteri bu kayıtları görüntüleyip uygun olanları iptal edebiliyor."
    ]
  },
  {
    "version": 259,
    "date": "2026-06-03",
    "title": "OpenCart Test Mağazası Müşteri Hesabına Bağlandı",
    "confidence": "operational",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "OpenCart test mağazası ilgili müşteri hesabına aktif olarak bağlandı.",
      "Şifreli API kimlik bilgileri kaydedildi ve ilk canlı senkronda 2.427 sipariş aktarıldı.",
      "Temel sipariş verileri müşteri panelinde görünür hale geldi; ürün satırları için admin veya özel endpoint gereksinimi korundu."
    ]
  },
  {
    "version": 258,
    "date": "2026-06-03",
    "title": "Cloudflare Sipariş Listesinde İade ve Void Kayıtlar Etiket Bekleyenlerden Çıkarıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "İade, iptal, tam iade, failed ve void ödeme durumundaki siparişler Etiket bekleyen filtresinden çıkarıldı.",
      "İade, iptal, failed ve void durumundaki siparişler tekli veya toplu etiket için seçilemiyor.",
      "Backend, kredi veya etiket kaynağı tüketilmeden işlemi durduruyor."
    ]
  },
  {
    "version": 257,
    "date": "2026-06-03",
    "title": "İade ve İptal Edilmiş Siparişlerin Gönderilebilir Sayılması Engellendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Refunded, cancelled, chargeback, void ve failed ödeme durumları gönderilebilir sipariş kapsamından çıkarıldı.",
      "İade veya iptal durumundaki kayıtların seçim ve etiket oluşturma aksiyonları kapatıldı; tekli ve toplu backend kontrolleri etiket kaynağı tüketilmeden işlemi durduruyor."
    ]
  },
  {
    "version": 256,
    "date": "2026-06-03",
    "title": "OpenCart API-Only Sipariş Tarama Fallback’i Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Admin bilgisi bulunmayan OpenCart mağazaları için API-only sipariş tarama fallback’i eklendi.",
      "Standart order info çağrısıyla sipariş kimlikleri taranarak adres, müşteri, tarih, toplam ve ülke bilgileri alınıyor.",
      "Ürün satırlarının standart API’de bulunmaması nedeniyle tam ürün detayı için admin erişimi veya özel endpoint gereksinimi korunuyor."
    ]
  },
  {
    "version": 255,
    "date": "2026-06-03",
    "title": "Gadget OpenCart Entegrasyonuna Şifreli API Kimlik Bilgileri Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "OpenCart bağlantısına API kullanıcı adı ve şifreli API anahtarı alanları eklendi.",
      "Bağlantı testinde API oturumu ve beyaz IP gereksinimi doğrulanıyor; gerekli IP kullanıcıya gösteriliyor.",
      "Mağaza durumu ve sipariş senkronu API kimlik bilgilerinin hazır olup olmadığını dikkate alıyor."
    ]
  },
  {
    "version": 254,
    "date": "2026-06-03",
    "title": "Shopify KDV Eksik Hesaplanırsa Brüt Satır Fallback’i Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Cloudflare ve Gadget checkout akışları önce Shopify’ın normal vergi hesabını kullanıyor.",
      "MwSt sıfır veya eksik dönerse draft yeniden oluşturulup ürünler yüzde 19 MwSt dahil brüt tutarla tek satırda gönderiliyor.",
      "Ayrı KDV ürünü oluşturmadan tahsilat toplamının eksik kalması engellendi."
    ]
  },
  {
    "version": 253,
    "date": "2026-06-03",
    "title": "Orijinal Görselden Koyu ve Açık Zemin Logo Varyantları Oluşturuldu",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Orijinal görselden koyu ve açık zemin için iki ayrı logo varyantı üretildi.",
      "Giriş ekranı ve açık arayüzlerde kontrast korunarak logonun kutu gibi görünmesi giderildi."
    ]
  },
  {
    "version": 252,
    "date": "2026-06-03",
    "title": "Gadget Checkout KDV ve Almanya Adres Normalizasyonu Düzeltildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Net fiyat üzerinden yüzde 19 MwSt hesaplaması Gadget checkout akışında netleştirildi.",
      "Almanya ülke adları Shopify’ın kabul ettiği Germany ve DE biçimine normalize ediliyor.",
      "Shopify vergi hesaplamazsa ayrı KDV ürünü yerine tek brüt satır oluşturuluyor."
    ]
  },
  {
    "version": 251,
    "date": "2026-06-03",
    "title": "Shopify Draft Order Hesaplama Tamamlanmadan Fatura Gönderimi Engellendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Shopify’ın draft order hesaplaması tamamlanmadı yanıtında işlem kısa aralıklarla yeniden kontrol ediliyor.",
      "Fatura yalnız hesaplama tamamlanıp invoice aktive edildikten sonra gönderiliyor.",
      "Hazır invoice URL yeniden okunarak kullanıcıya geçerli ödeme bağlantısı veriliyor."
    ]
  },
  {
    "version": 250,
    "date": "2026-06-02",
    "title": "Yeni KenPost Logo ve Favicon Seti Tüm Aktif Sistemlere Eklendi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Yeni KenPost wordmark logosu ile favicon ve uygulama ikonu aktif arayüzlere eklendi.",
      "Meta, Open Graph, Twitter başlıkları ve tema rengi yeni marka kimliğiyle hizalandı.",
      "Giriş, müşteri, admin ve tarayıcı sekmesi markalama alanları aynı varlık setini kullanıyor."
    ]
  },
  {
    "version": 249,
    "date": "2026-06-02",
    "title": "Bekleyen Ödeme Paneli Gizlenirken Otomatik Kontrol Korundu",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Müşteriye görünen Bekleyen ödeme kartı ile manuel iptal ve kontrol butonları kaldırıldı.",
      "Arka plandaki otomatik ödeme kontrolü ve ödeme sonrası bakiye uzlaştırması korunuyor."
    ]
  },
  {
    "version": 248,
    "date": "2026-06-02",
    "title": "Shopify Draft Invoice Hazır Olmadan Açılma Hatası Giderildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Checkout oluşturulduktan sonra Shopify draft invoice aktive ediliyor ve güncel invoice URL yeniden okunmadan ödeme sayfası açılmıyor.",
      "Yeni ödeme akışı Cloudflare ve Gadget tarafında aynı davranışa getirildi; eski bekleyen draft bağlantıları yeni checkout ile yenilenebiliyor."
    ]
  },
  {
    "version": 247,
    "date": "2026-06-02",
    "title": "OpenCart Sabit IP Relay Servisi Kuruldu ve Bağlantı Doğrulandı",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Sabit IP kullanan relay servisi production ortamına bağlandı ve API erişimi doğrulandı.",
      "Standart OpenCart API’nin sipariş listeleme sınırlaması tespit edilerek admin veya özel endpoint gereksinimi netleştirildi."
    ]
  },
  {
    "version": 246,
    "date": "2026-06-02",
    "title": "OpenCart Bağlantısına API ve Admin Modları Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "OpenCart mağazaları API anahtarı/beyaz IP veya admin erişimiyle bağlanabilir hale getirildi.",
      "Bağlantı formu iki farklı kurulum modelini açık biçimde ayırıyor."
    ]
  },
  {
    "version": 245,
    "date": "2026-06-02",
    "title": "Müşteri Sidebar Kredi ve Hesap Alanları Yeniden Düzenlendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Sidebar’daki yinelenen kullanıcı ve çıkış bloğu kaldırıldı; çıkış işlemi sağ üstte bırakıldı.",
      "Alt bölüm Kredi Durumu, Profil, Ekip yönetimi ve Bize ulaşın kutularıyla yeniden düzenlendi.",
      "Sol menü referans tasarıma daha yakın ve daha kompakt hale getirildi."
    ]
  },
  {
    "version": 244,
    "date": "2026-06-02",
    "title": "Dashboard ve Sidebar Tekrarlı Alanlardan Arındırıldı",
    "confidence": "implemented",
    "audience": [
      "customer"
    ],
    "items": [
      "Müşteri dashboard’undaki tekrarlı operasyon paneli kaldırılarak üst bölüm daha kompakt hale getirildi; ikinci çıkış butonu kaldırıldı.",
      "Mağazalar ekranında Amazon logosu ve bağlantı çevirisi düzeltildi; siparişler için varsayılan aralık yedi gün yapıldı ve tek aktif mağaza otomatik seçiliyor."
    ]
  },
  {
    "version": 243,
    "date": "2026-06-02",
    "title": "Gadget Satın Alma Akışına KDV Hesabı ve Cloudflare Paritesi Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Gadget satın alma ekranına Cloudflare’daki net fiyat, yüzde 19 MwSt ve brüt toplam modeli taşındı.",
      "Checkout metadata’sı ve fatura hesapları aynı KDV mantığına hizalandı; ürün fiyatları net bazda korunuyor."
    ]
  },
  {
    "version": 242,
    "date": "2026-06-02",
    "title": "Shopify Ödeme Kontrolü Kullanıcı Müdahalesi Olmadan Otomatikleştirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Checkout açma ve ödemeyi doğrulama butonları kaldırıldı.",
      "Ödeme durumu sayfa açılışında, geri dönüşte ve periyodik olarak otomatik kontrol ediliyor."
    ]
  },
  {
    "version": 241,
    "date": "2026-06-02",
    "title": "Etiket Satın Almada Net, KDV ve Brüt Tutarlar Ayrıştırıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiket fiyatı net, yüzde 19 MwSt ve brüt toplam olarak ayrı gösteriliyor.",
      "Müşteri adresi Shopify draft order’a fatura ve teslimat adresi olarak aktarılıyor.",
      "Shopify vergi hesaplaması ve taxesIncluded davranışı bu net-brüt modele göre hizalandı."
    ]
  },
  {
    "version": 240,
    "date": "2026-06-01",
    "title": "Adres Ayrıştırma, Firma Algılama ve Son Etiket Yeniden Kullanımı Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Tek metin kutusundan alıcı ve adres alanları ayrıştırılabiliyor; firma satırları otomatik algılanabiliyor.",
      "Önceki manuel alıcıyı yeniden kullanma ve son etiketlerde indirme, yenileme, iptal işlemleri eklendi."
    ]
  },
  {
    "version": 239,
    "date": "2026-06-01",
    "title": "Manuel Etiket Akışı Tekli ve Toplu Modlara Ayrıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Manuel etiket sayfası “Tekli manuel” ve “Toplu import” sekmeleriyle yeniden düzenlendi.",
      "Ürün ve gönderi tipi ortak seçenekler altında toplandı; siparişten etiket oluşturma akışı ayrı tutuldu."
    ]
  },
  {
    "version": 238,
    "date": "2026-06-01",
    "title": "Sipariş Özet Önbelleği ve Oturum Yazma Sıklığı Optimize Edildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Ürün, tutar ve tarih özetleri D1 önbelleğine alınarak her liste açılışında büyük S3 kayıtlarının okunması önlendi.",
      "Oturum son görülme yazımları seyreltilerek gereksiz veritabanı yükü azaltıldı."
    ]
  },
  {
    "version": 237,
    "date": "2026-06-01",
    "title": "Sipariş API Sorguları ve D1 İndeksleri Optimize Edildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Gereksiz gruplayan ve geniş join kullanan sipariş sorguları sadeleştirildi.",
      "Canlı D1’e sipariş listeleme için performans indeksi eklendi."
    ]
  },
  {
    "version": 236,
    "date": "2026-06-01",
    "title": "Müşteri Paneline Kargo Sağlığı Raporu Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "DHL sağlık kartları, operasyon hunisi, müdahale gereken gönderiler ve alarm özeti eklendi.",
      "Ürün, mağaza, platform ve şehir kırılımları gerçek takip verileri geldikçe API tarafından dolduruluyor."
    ]
  },
  {
    "version": 235,
    "date": "2026-06-01",
    "title": "Sipariş Detay ve Etiket Aksiyonları Sipariş Numarasının Altına Taşındı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Detay ve etiket veya PDF aksiyonları gizli sağ sütundan sipariş numarasının altına taşındı.",
      "Kullanıcılar yatay kaydırma yapmadan temel sipariş işlemlerine erişebiliyor."
    ]
  },
  {
    "version": 234,
    "date": "2026-06-01",
    "title": "Sipariş Ürün Detayları Hover Popover ile Görünür Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "system"
    ],
    "items": [
      "Sipariş listesinde `1 item / 2 items` üzerine gelince ürün detay popover’ı açılıyor.",
      "Popover’da ürün adı, adet, varsa `SKU`, `ASIN`, birim/toplam tutar görünüyor.",
      "Aynı özet sipariş detay sayfasındaki `Items` alanında da çalışıyor."
    ]
  },
  {
    "version": 233,
    "date": "2026-06-01",
    "title": "Sol Menüde Ürün Bazlı Etiket Bakiyesi Kırılımı Gösterildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Sol menüdeki Kredi Durumu kartı ürün ve kilogram bazlı bakiye kırılımını gösteriyor.",
      "Kartta özetlenen ürünlerin tamamı açılan detay görünümünde incelenebiliyor.",
      "Eksik ürün adları ağırlık bazlı okunur yedek adlarla gösteriliyor."
    ]
  },
  {
    "version": 232,
    "date": "2026-06-01",
    "title": "Pazaryeri Bağlantı Formları Platforma Özel Rehberlerle Yenilendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Shopify, Billbee, OTTO, JTL, WooCommerce, Kaufland ve OpenCart için platforma özel bağlantı rehberleri eklendi.",
      "Bağlantı ekranlarına gereken bilgiler, kurulum adımları ve alan açıklamaları eklendi.",
      "Amazon seçimi doğrudan özel Amazon bağlantı akışına yönlendiriliyor."
    ]
  },
  {
    "version": 231,
    "date": "2026-06-01",
    "title": "Raporlar Menüsü Operasyon Bölümünün Altına Taşındı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Raporlar bağlantısı etiket envanterinin altında, hesap bağlantılarından önce konumlandırıldı."
    ]
  },
  {
    "version": 230,
    "date": "2026-06-01",
    "title": "Sipariş İşlemleri Kaydırma Gerektirmeden Görünür Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Sipariş detay ve etiket işlemleri sipariş numarasının altında doğrudan gösteriliyor.",
      "Geniş tablolarda işlem kolonunun ekran dışında kalması nedeniyle oluşan erişim sorunu giderildi."
    ]
  },
  {
    "version": 229,
    "date": "2026-06-01",
    "title": "Gönderi Satırı İşlemleri Tek Aksiyon Menüsünde Toplandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Detay, PDF, ZIP, senkron, yenileme ve iptal işlemleri tek Aksiyon menüsünde toplandı.",
      "PDF aksiyonu tarayıcıda açmak yerine doğrudan indirme davranışına geçirildi.",
      "Listeyi yenile ile Etiketi yenile ifadeleri birbirinden ayrıldı."
    ]
  },
  {
    "version": 228,
    "date": "2026-06-01",
    "title": "Etiket Envanteri PDF, ZIP ve CSV İndirmeleri Uygulama Rotasına Taşındı",
    "confidence": "verified",
    "audience": [
      "admin",
      "system"
    ],
    "items": [
      "PDF, ZIP ve CSV indirmeleri imzalı object-storage bağlantıları yerine KenPost uygulama rotalarından sunuluyor.",
      "İmza uyuşmazlığına yol açan doğrudan dosya yönlendirmesi kaldırıldı.",
      "Envanter başlığı, aksiyonları, sütunları ve durum rozetleri düzenlenip kalan İngilizce etiketler Türkçeleştirildi."
    ]
  },
  {
    "version": 227,
    "date": "2026-06-01",
    "title": "Etiket Satın Alma Sırası ve Shopify Ödeme Dönüşü Güçlendirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Etiket ürünleri Kleinpaket ve 1 kg ile başlayıp ağırlığa göre operasyonel sıraya alındı.",
      "Shopify ödeme dönüşü idempotent hale getirildi; webhook ve manuel doğrulamanın çift işlem yapması engellendi.",
      "Kullanıcı KenPost sekmesine döndüğünde bekleyen ödeme otomatik kontrol ediliyor."
    ]
  },
  {
    "version": 226,
    "date": "2026-06-01",
    "title": "Referans Sayfasına Arama ve Komisyon Filtreleri Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Referans sayfasına arama, komisyon durumu filtresi, sayımlı tablolar ve daha net referans bağlantı paneli eklendi."
    ]
  },
  {
    "version": 225,
    "date": "2026-06-01",
    "title": "Etiket Satın Alma Faturaları Uygulama Üzerinden Güvenli Açılır Hale Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Fatura PDF’leri doğrudan imzalı object-storage bağlantısı yerine KenPost’un güvenli dosya rotasından sunuluyor.",
      "SignatureDoesNotMatch XML hatasına yol açan doğrudan indirme yolu kaldırıldı.",
      "PDF aksiyonu güvenli uygulama indirme adresini önceliklendiriyor."
    ]
  },
  {
    "version": 224,
    "date": "2026-06-01",
    "title": "Kaufland Sipariş Ürün Özetleri Liste Ekranına Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Kaufland OrderItems verisi ürün adedi ve ürün önizleme özetine dönüştürülüyor.",
      "Sipariş listesinde ürün sayısının altında ürün özeti gösteriliyor.",
      "Yeni Kaufland senkronlarında toplam tutar bilgisi de sipariş önbelleğine yazılıyor."
    ]
  },
  {
    "version": 223,
    "date": "2026-06-01",
    "title": "Sipariş Kontrol Paneli Mağaza, Ürün ve Senkron Bölümlerine Ayrıldı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sipariş kontrol paneli Mağaza, Etiket ürünü ve Senkronizasyon bölümlerine ayrıldı.",
      "Metrikler ve aksiyonlar hizalandı; mobil görünüm tek kolonlu akışa geçirildi."
    ]
  },
  {
    "version": 222,
    "date": "2026-06-01",
    "title": "Müşteri Raporlarına Filtre, Önizleme ve Dışa Aktarım Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Raporlarda filtreler, özet kartları ve tablo önizlemesi sunuluyor.",
      "Sonuçlar CSV ve Excel biçiminde dışa aktarılabiliyor."
    ]
  },
  {
    "version": 221,
    "date": "2026-06-01",
    "title": "Müşteri Paneline Rapor Merkezi ve Detay Sayfaları Eklendi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Müşteri menüsüne Raporlar alanı ile rapor kataloğu ve rapor detay rotaları eklendi.",
      "Admin rapor modeline paralel müşteri odaklı operasyon raporları oluşturuldu."
    ]
  },
  {
    "version": 220,
    "date": "2026-06-01",
    "title": "Müşteri Dashboard’u Operasyon Genel Bakışına Dönüştürüldü",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Büyük koyu karşılama alanı kaldırılarak sade Genel Bakış başlığı ve ana aksiyonlar eklendi.",
      "Mağaza, sipariş, gönderi ve hazır etiket KPI kartları oluşturuldu.",
      "Operasyon özeti, hızlı işlemler, gönderi sinyalleri ve son hareketler tek dashboard’da toplandı."
    ]
  },
  {
    "version": 219,
    "date": "2026-06-01",
    "title": "Etiket Bakiyeleri Sayfası Mağaza Listesi Tasarımına Yaklaştırıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Üst başlık ve özet kartlarının görsel ritmi mağazalar ekranıyla hizalandı.",
      "Ürün bakiyeleri kart ızgarası yerine mağaza satırlarına benzeyen listeye dönüştürüldü.",
      "Kredi hareketleri için ayrı bir yan panel eklendi."
    ]
  },
  {
    "version": 218,
    "date": "2026-06-01",
    "title": "Sipariş Listesine Tarih, Adres, Ürün, Tutar ve Takip Detayları Geri Getirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Sipariş listesine tarih, müşteri ve adres, ürünler, toplam tutar, ödeme, fulfillment, ülke ve takip bilgileri eklendi.",
      "Ürün, tutar, ödeme ve fulfillment özetleri mağazanın önbelleğe alınmış pazaryeri siparişinden okunuyor; veri yoksa yanıltıcı sıfır değer yerine boş durum gösteriliyor.",
      "Tarih görünümü yıl bilgisi dahil olacak şekilde standardize edildi."
    ]
  },
  {
    "version": 217,
    "date": "2026-06-01",
    "title": "Müşteri Mağazalar Sayfası Daha Kompakt Operasyon Düzenine Geçirildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Bağlı mağazalar ve yeni bağlantılar yan yana, daha kompakt bir düzene alındı.",
      "Büyük pazaryeri kartları daha sıkı ve okunur bir bağlantı listesine dönüştürüldü.",
      "Mağaza satırlarında ad, platform, durum, sipariş sayısı, son senkron ve işlemler ayrı alanlarda gösteriliyor."
    ]
  },
  {
    "version": 216,
    "date": "2026-06-01",
    "title": "Gönderi Araması, CSV ve Toplu Takip Senkronu Genişletildi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Gönderi API’sine tam adres alanları eklendi; arama ve CSV dışa aktarımı adres bilgisini kapsıyor.",
      "Sayfadaki gönderiler seçilerek toplu kaynak-platform takip senkronuna gönderilebiliyor."
    ]
  },
  {
    "version": 215,
    "date": "2026-06-01",
    "title": "Müşteri Gönderileri Daha Okunabilir Operasyon Listesine Dönüştürüldü",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Adres, tarih, takip, etiket durumu ve temel işlemler daha okunabilir satırlarda gösteriliyor.",
      "Detay, indirme, senkron, yenileme ve iptal işlemleri gönderi bağlamında erişilebilir hale getirildi."
    ]
  },
  {
    "version": 214,
    "date": "2026-06-01",
    "title": "Tüm Desteklenen Pazaryerleri Mağaza Ekleme Listesinde Gösterildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Bağlı bir mağazası bulunan platformlar artık bağlantı listesinden gizlenmiyor.",
      "Müşteriler aynı platform için ek mağaza bağlantısı oluşturabiliyor ve bağlı mağaza sayısını görebiliyor."
    ]
  },
  {
    "version": 213,
    "date": "2026-06-01",
    "title": "Sıfır Özel Fiyatların Baz Fiyatı Ezmesi Engellendi",
    "confidence": "verified",
    "audience": [
      "admin",
      "customer"
    ],
    "items": [
      "Aktarım kaynaklı sıfır özel fiyat kayıtlarının baz satış fiyatını ezmesi engellendi.",
      "Özel fiyat yalnız sıfırdan büyükse uygulanıyor; 0 veya 0,00 kayıtları baz fiyata düşüyor.",
      "Aynı kural satın alma, checkout, admin tahsis, komisyon ve yeniden fiyatlama akışlarına uygulandı."
    ]
  },
  {
    "version": 212,
    "date": "2026-06-01",
    "title": "Müşteri Paneli Daha Kompakt Masaüstü Yoğunluğuna Geçirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Logo altındaki “Müşteri paneli / v201” alanı kaldırıldı ve menü yukarı taşındı.",
      "Masaüstü yoğunluğu ve menü yazı ölçüleri yüzde 100 tarayıcı yakınlaştırmasında daha kompakt görünecek şekilde ayarlandı."
    ]
  },
  {
    "version": 211,
    "date": "2026-06-01",
    "title": "Etiket Bakiyeleri Sayfası Hareket ve Ürün Özetiyle Yeniden Tasarlandı",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Üst özet kartları, ürün bazlı bakiyeler, satın alma ve bakiye hareketleri tablosu, arama ve filtreler eklendi.",
      "Bakiye API’si satın alma kayıtlarını, ürün toplamlarını, hareketleri ve genel toplamları döndürecek şekilde genişletildi."
    ]
  },
  {
    "version": 210,
    "date": "2026-06-01",
    "title": "Shopify Çok Satırlı Checkout ve Webhook İşleme Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Shopify draft order artık birden fazla ürün satırıyla oluşturuluyor.",
      "Ödenen siparişin her satırı ayrı bakiyeye işleniyor; eski tek ürün checkout kayıtlarıyla uyumluluk korundu."
    ]
  },
  {
    "version": 209,
    "date": "2026-06-01",
    "title": "Etiket Satın Alma Ekranı Sepet Modeline Geçirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Müşteriler birden fazla etiket ürününü ve adedini aynı sepette yönetebilir hale geldi.",
      "Satır toplamı, toplam adet ve ödenecek genel toplam aynı ekranda gösteriliyor."
    ]
  },
  {
    "version": 208,
    "date": "2026-06-01",
    "title": "Sipariş Kontrol Panelindeki Ürün ve Durum Bilgileri Netleştirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Etiket ürünleri operasyonel ağırlık sırasına göre listelendi.",
      "Senkron aralığı liste filtresinden ayrıldı; kredi, ağırlık ve son senkron bilgileri görünür hale getirildi."
    ]
  },
  {
    "version": 207,
    "date": "2026-06-01",
    "title": "Çoklu Mağaza Senkronizasyonu ve İlerleme Penceresi Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Tek aktif mağaza otomatik seçiliyor; birden fazla mağazada “Tüm mağazalar” seçeneği kullanılabiliyor.",
      "Tüm aktif mağazalar sırayla senkronlanırken kapanabilir ilerleme penceresi gösteriliyor."
    ]
  },
  {
    "version": 206,
    "date": "2026-06-01",
    "title": "Mağaza Senkronizasyon Logları ve Çalışma Kayıtları Eklendi",
    "confidence": "verified",
    "audience": [
      "customer",
      "system"
    ],
    "items": [
      "Müşterilerin senkron denemelerini görebileceği log rotası ve API eklendi.",
      "Senkron çalışmaları için kayıt tablosu oluşturuldu; pasif mağazaların gereksiz otomatik denemeleri durduruldu."
    ]
  },
  {
    "version": 205,
    "date": "2026-06-01",
    "title": "Mağaza İşlemleri Tek Aksiyon Menüsünde Toplandı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Mağaza satırı ve mağaza detayındaki dağınık işlemler tek menü altında birleştirildi.",
      "Sipariş alma aksiyonu daha açık bir ifadeyle “Senkronizasyonu başlat” olarak yeniden adlandırıldı."
    ]
  },
  {
    "version": 204,
    "date": "2026-06-01",
    "title": "Mağazalar Sayfası Bağlı Mağazaları Önceleyen Sade Yapıya Geçirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Bağlı mağazalar listesi sayfanın üstüne taşındı; yeni bağlantılar daha aşağıda sunuluyor.",
      "Gereksiz manuel mağaza, eBay OAuth ve yeniden bağlama butonları kaldırıldı.",
      "Bağlı platformların yeniden “Bağla” olarak görünmesi ve boş aktiflik değerlerinin pasif sayılması düzeltildi."
    ]
  },
  {
    "version": 203,
    "date": "2026-06-01",
    "title": "Siparişler Sayfasındaki Büyük Başlık Kartı Kaldırıldı",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Siparişler ekranı kompakt başlıkla daha yukarıdan başlayacak şekilde düzenlendi.",
      "Liste için daha fazla dikey çalışma alanı bırakıldı."
    ]
  },
  {
    "version": 202,
    "date": "2026-06-01",
    "title": "Müşteri Paneli Üst Çubuğu ve Sol Menü Sadeleştirildi",
    "confidence": "verified",
    "audience": [
      "customer"
    ],
    "items": [
      "Karşılama alanı firma bilgisiyle sadeleştirildi; kullanıcı bilgileri sağ tarafta daha okunur hale getirildi.",
      "Dil seçimindeki gereksiz ikon kaldırıldı ve sol menü logosu ortalandı."
    ]
  }
];

export const releaseNotesV202ToV461: ReleaseEntry[] = releaseSources.map(({ items, ...release }) => ({
  ...release,
  summary: items[0],
  highlights: items.length > 1 ? items.slice(1) : items,
  details: [{ title: "Değişiklikler", items }],
}));
